var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// ../repo-data-parse/src/lib/utils/slugify.ts
var slugify = (str) => str.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");

// ../repo-data-parse/src/lib/utils/splitter.ts
var DEFAULT_DELIMITER = /[,\n;]/;
var splitter = (data, delimiter = DEFAULT_DELIMITER) => {
  const o = data;
  if (!o) {
    return [];
  }
  if (typeof o === "string") {
    return o.split(delimiter).map((h) => h.trim());
  }
  return [];
};

// ../repo-data-parse/src/lib/column.ts
var ResolvedColumn = class {
  constructor(columnDef, data) {
    if (columnDef.strip) {
      console.warn("strip is deprecated, use trim instead");
      columnDef.trim = columnDef.strip;
    }
    this._columnDef = columnDef;
    this._data = data;
  }
  getUniqueValues(sort = true) {
    const map = /* @__PURE__ */ new Map();
    this._data.forEach((row) => {
      const valArr = this.getRowUniqueValues(row);
      valArr.forEach((val) => {
        map.set(val, (map.get(val) || 0) + 1);
      });
    });
    const rawArr = Array.from(map.entries()).map(([label, count]) => {
      return __spreadProps(__spreadValues({}, this.getLabelValue(label)), {
        count
      });
    });
    const arr = rawArr.reduce((acc, val) => {
      const prev = acc.find((a) => a.slug === val.slug);
      if (prev) {
        prev.count += val.count;
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
    if (sort) {
      arr.sort((a, b) => b.count - a.count);
    }
    return arr;
  }
  getRowUniqueValues(row, filter = true) {
    if (this._columnDef.getUniqueValues) {
      return this._columnDef.getUniqueValues(row);
    }
    const data = this.accessor(row);
    if (Array.isArray(data)) {
      return [
        ...new Set(
          data.filter((r) => {
            if (filter) {
              if (typeof r === "string") {
                return r.trim() !== "";
              }
              return r !== void 0;
            }
          })
        )
      ];
    }
    if (!data) {
      return [];
    }
    return [data];
  }
  getLabelValues(vals) {
    return vals.map((val) => this.getLabelValue(val));
  }
  getLabelValue(val) {
    if (this._columnDef.getLabelValue) {
      return this._columnDef.getLabelValue(val);
    }
    return {
      slug: slugify(String(val)),
      label: val
    };
  }
  //   filterRowsByValue(value: TValue) {
  //   }
  filterRowsBySlug(slug) {
    return this._data.filter((row) => {
      const slugs = this.getRowSlugs(row);
      return slugs.includes(slug);
    });
  }
  // displayFilterRowsBySlug(slug: string) {
  //   const data = this.filterRowsBySlug(slug);
  //   const row = this.accessor(data[0]);
  //   const label = this.getLabelValue(row);
  //   return {
  //     title: label.label,
  //     data,
  //   };
  // }
  findRowBySlug(slug) {
    return this._data.find((row) => {
      const slugs = this.getRowSlugs(row);
      return slugs.includes(slug);
    });
  }
  findRowByValue(value) {
    return this._data.find((row) => {
      const vals = this.getRowUniqueValues(row);
      return vals.includes(value);
    });
  }
  getRowSlugs(row) {
    const res = this.accessor(row);
    if (Array.isArray(res)) {
      return res.map((r) => this.getLabelValue(r).slug);
    }
    return [this.getLabelValue(res).slug];
  }
  rowAccessor(row) {
    if (this._columnDef.useLabeledValue) {
      const res = this.accessor(row);
      if (Array.isArray(res)) {
        return res.map((r) => this.getLabelValue(r));
      }
      return this.getLabelValue(res);
    }
    return this.accessor(row);
  }
  shouldFilterRow(row) {
    if (this._columnDef.shouldFilter) {
      return this._columnDef.shouldFilter(row);
    }
    return false;
  }
  accessor(row) {
    if ("accessorKey" in this._columnDef) {
      return row[this._columnDef.accessorKey];
    }
    const data = this._columnDef.accessorFn(row);
    if (Array.isArray(data)) {
      return data.map((d) => {
        if (this._columnDef.trim) {
          return String(d).trim();
        }
        return d;
      }).filter((v) => {
        if (this._columnDef.filterEmpty) {
          return !!v;
        }
        return true;
      });
    }
    return data;
  }
};

// ../repo-data-parse/src/lib/utils/filter-undefined.ts
function isDefined(x) {
  return x !== void 0;
}

// ../repo-data-parse/src/lib/index.ts
var DataParser = class {
  constructor(options) {
    this._columnDefs = options.columns;
    this._data = options.data;
  }
  get columns() {
    if (!this._columns || Object.keys(this._columns).length !== Object.keys(this._columnDefs).length) {
      const _columns = {};
      for (const key in this._columnDefs) {
        _columns[key] = new ResolvedColumn(
          this._columnDefs[key],
          this._data
        );
        this._columns = _columns;
      }
    }
    return this._columns;
  }
  findRowBySlug(col, slug) {
    const column = this.getColumn(col);
    const row = column.findRowBySlug(slug);
    if (!row) {
      return null;
    }
    return this.getRow(row);
  }
  filterColumnBySlug(col, slug) {
    const column = this.getColumn(col);
    const rows = column.filterRowsBySlug(slug);
    return this.formatRows(rows);
  }
  filterColumnBySlugWithDisplay(col, slug) {
    const column = this.getColumn(col);
    const rows = column.filterRowsBySlug(slug);
    const vals = column.getUniqueValues();
    const title = vals.find((v) => v.slug === slug);
    return {
      title: title == null ? void 0 : title.label,
      data: this.formatRows(rows)
    };
  }
  getColumn(key) {
    return this.columns[key];
  }
  formatRows(rows) {
    return rows.map((row) => this.getRow(row)).filter(isDefined);
  }
  getRow(row) {
    const res = {};
    for (const key in this._columnDefs) {
      const col = this.getColumn(key);
      if (col.shouldFilterRow(row)) {
        return void 0;
      }
      res[key] = col.rowAccessor(row);
    }
    return res;
  }
  getData() {
    return this.formatRows(this._data);
  }
};

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/createLucideIcon.js
import { forwardRef as forwardRef2, createElement as createElement2 } from "react";

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/shared/src/utils.js
var toKebabCase = (string) => string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
var toCamelCase = (string) => string.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (match, p1, p2) => p2 ? p2.toUpperCase() : p1.toLowerCase()
);
var toPascalCase = (string) => {
  const camelCase = toCamelCase(string);
  return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
var mergeClasses = (...classes) => classes.filter((className, index, array) => {
  return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
}).join(" ").trim();

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/Icon.js
import { forwardRef, createElement } from "react";

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/defaultAttributes.js
var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/Icon.js
var Icon = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      color = "currentColor",
      size = 24,
      strokeWidth = 2,
      absoluteStrokeWidth,
      className = "",
      children,
      iconNode
    } = _b, rest = __objRest(_b, [
      "color",
      "size",
      "strokeWidth",
      "absoluteStrokeWidth",
      "className",
      "children",
      "iconNode"
    ]);
    return createElement(
      "svg",
      __spreadValues(__spreadProps(__spreadValues({
        ref
      }, defaultAttributes), {
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: mergeClasses("lucide", className)
      }), rest),
      [
        ...iconNode.map(([tag, attrs]) => createElement(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    );
  }
);

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/createLucideIcon.js
var createLucideIcon = (iconName, iconNode) => {
  const Component = forwardRef2(
    (_a, ref) => {
      var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
      return createElement2(Icon, __spreadValues({
        ref,
        iconNode,
        className: mergeClasses(
          `lucide-${toKebabCase(toPascalCase(iconName))}`,
          `lucide-${iconName}`,
          className
        )
      }, props));
    }
  );
  Component.displayName = toPascalCase(iconName);
  return Component;
};

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/icons/book-open-check.js
var __iconNode = [
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  [
    "path",
    {
      d: "M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3",
      key: "8arnkb"
    }
  ]
];
var BookOpenCheck = createLucideIcon("book-open-check", __iconNode);

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/icons/briefcase-business.js
var __iconNode2 = [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0", key: "12hx5q" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
];
var BriefcaseBusiness = createLucideIcon("briefcase-business", __iconNode2);

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/icons/calculator.js
var __iconNode3 = [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
];
var Calculator = createLucideIcon("calculator", __iconNode3);

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/icons/flame-kindling.js
var __iconNode4 = [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
];
var FlameKindling = createLucideIcon("flame-kindling", __iconNode4);

// ../../node_modules/.pnpm/lucide-react@0.487.0_react@19.1.0/node_modules/lucide-react/dist/esm/icons/trophy.js
var __iconNode5 = [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
];
var Trophy = createLucideIcon("trophy", __iconNode5);

// src/lib/curriculum-type/index.ts
var CurriculumTypes = {
  // 'STEM Curriculums': {
  //   display: false,
  // },
  "After-School STEM Programs": {
    display: true,
    icon: BookOpenCheck,
    description: "After-school programs that focus on STEM subjects."
  },
  "Summer Camps and Bootcamps": {
    display: true,
    icon: FlameKindling
  },
  "Competitions and Challenges": {
    display: true,
    icon: Trophy
  },
  "Work-based Learning opportunities": {
    display: true,
    icon: BriefcaseBusiness
  }
};
var getCurriculumType = (key) => {
  if (key in CurriculumTypes) {
    return CurriculumTypes[key];
  }
};

// data.json
var data_default = {
  data: [
    {
      row_id: 2,
      "Program Name": "Albuquerque Aviation Academy",
      Organization: "PED - Magnet/Charter Schools",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "Special STEM Schools or Magnet Programs, STEM Curriculums, Career Pathways Programs/WBL",
      Age: "HS, Middle",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Founded in 2012, Albuquerque Aviation Academy is a free, public STEAM charter school located in our brand new facility in the Ventana Ranch community that prepares students in grades 6-12 for college and career in a unique, stimulating atmosphere where innovation and imagination soar"
    },
    {
      row_id: 3,
      "Program Name": " Arduino-Based Robotic Combat Bot at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary, Middle",
      "Curriculum Focus Area ": "Robotics",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Experiment with design options and work through a conceptual structural design as you build a robot. Learn to program an Arduino-based remote-operated robot, and hold an end-of-week tournament to see whose robot is the most robust and durable. You'll also get to experiment with some more advanced robots from New Mexico Tech.\n\nOffered in Collaboration with NM Tech Mechanical Eng Robotic STEM Outreach Programs "
    },
    {
      row_id: 4,
      "Program Name": "Engineering in Space: NASA Style Rover System at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "HS",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Design, fabricate, and program a robotic arm attachment for an existing six-wheel rover platform. See if you can complete the mission of opening the external door of the Lunar base from its outside. To complete this mission, your team must design the attachment to operate the external release level and attach it to an existing rover platform. You'll then have to operate your design remotely through a first-person view headset. \n\nOffered in Collaboration with NM Tech Mechanical Eng Robotic STEM Outreach Programs"
    },
    {
      row_id: 5,
      "Program Name": " STEM Mentor Collective",
      Organization: "Northern New Mexico College (NNMC)",
      "Program Support Mechanisms": "Train the Trainers, Out of School Time (OST) Programs",
      "Type of Curriculum": "Mentorship Programs for Educators, After-School STEM Programs, Teacher Training Programs",
      Age: "Elementary, Middle, HS, College, Educator",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "To that end we develop and deliver exciting, mentor-fueled, hands-on, STEAM programming in K12 classrooms in Northern New Mexico. We recruit and train college-age mentors, encourage K12 students to recruit mentors into their lives, and support K12 teachers through focused Communities of Practice. Our key partners are STEM Santa Fe, Los Alamos National Laboratory Foundation, The Computer Science Alliance, and Moving Arts Espanola.",
      Partners: "",
      Website: "https://sites.google.com/a/nnmc.edu/stem-mentor-collective/"
    },
    {
      row_id: 6,
      "Program Name": "A Gold Star Academy Summer Camp",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Middle, Elementary",
      "Curriculum Focus Area ": "STEM",
      Location: "Farmington",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "A Gold Star Academy Summer Camp: This program provides a variety of activities, including gardening, STEM projects, arts and crafts, and more, aiming to offer a summer full of trips, adventures, and fun in the sun for children aged 5-12."
    },
    {
      row_id: 7,
      "Program Name": "Academy for Technology and the Classics (ATC)",
      Organization: "PED - Magnet/Charter Schools",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "STEM Curriculums, Special STEM Schools or Magnet Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Technology, Math, Engineering",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged",
      Overview: "These schools offer a diverse range of STEM-focused programs, helping students develop skills in science, technology, engineering, and math through innovative and experiential learning approaches.",
      Partners: "",
      Website: "https://www.atcschool.org/"
    },
    {
      row_id: 8,
      "Program Name": "Accelerating Resillence Innovations in Drylands (UNM's ARID)",
      Organization: "University of New Mexico (UNM)",
      "Program Support Mechanisms": "Higher Ed, Internships/WBL",
      "Type of Curriculum": "Dual Credit/CTE (STEM), Work-based Learning opportunities, Internship/Apprenticeship",
      Age: "College",
      "Curriculum Focus Area ": "STEM, Conservation",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Undergraduate and graduate students from all departments at UNM are invited to apply for a $5,000 research grant to undertake interdisciplinary research related to resilience in New Mexico. Students are encouraged to develop the research project in partnership with an external UNM entity, such as a community group, Pueblo or Tribe, business, management agency, or non-profit, to address a real-world problem facing that group.",
      Partners: "",
      Website: "https://arid.unm.edu/student-opportunities/index.html"
    },
    {
      row_id: 9,
      "Program Name": "Career STREAM Summer Internships by AFRL ",
      Organization: "Air Force Research Lab (AFRL)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships, Internships/WBL",
      "Type of Curriculum": "Industry-Sponsored Programs/Internships, Summer Camps and Bootcamps, Internship/Apprenticeship",
      Age: "HS",
      "Curriculum Focus Area ": "Space, Robotics",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "6-week summer paid internship. Students can apply for ANY of the listed locations (UNM, NMT or virtual). Internships provide professional learning experiences that offer meaningful, practical work assignments related to a field of study or career interest. Interns develop and improve skills in communication, technology, research, and teamwork.\n",
      Partners: "University of New Mexico (UNM), NM Tech",
      Website: "https://afrlnm.com/stem/stem-opportunities/#:~:text=Career%20STREAM%20is%20a%206,on%20a%20team%20STEM%20project."
    },
    {
      row_id: 10,
      "Program Name": "Air Force Research Lab (AFRL) Scholars",
      Organization: "Air Force Research Lab (AFRL) Foundation",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships, Internships/WBL",
      "Type of Curriculum": "Industry-Sponsored Programs/Internships, Work-based Learning opportunities, Industry Visits and Tours, Internship/Apprenticeship",
      Age: "College",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The Air Force Research Laboratory (AFRL) Scholars Program offers stipend-paid internship opportunities for undergraduate and graduate-level university students pursuing STEM degrees, as well as upper-level high school students; select locations also offer internships to university students pursuing education-related degrees and K-12 professional educators.\nThe selected interns gain valuable hands-on experiences working with full-time AFRL scientists and engineers on cutting-edge research and technology and are able to contribute to unique, research-based projects. Graduate interns are able to collaborate with AFRL on current research and incorporate the research into their graduate work.",
      Partners: "University of New Mexico (UNM), NM Tech",
      Website: "https://afrlscholars.usra.edu/"
    },
    {
      row_id: 11,
      "Program Name": "Albuquerque Academy Summer STEM Camps",
      Organization: "Albquerque Academy",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "1 week and 3 week summer camps with Science and math tracks",
      Partners: "Albuquerque Academy",
      Website: "https://www.aa.edu/public-programs/think-summer/",
      "Program Contact": "",
      Email: "",
      Phone: "(505) 828-3200"
    },
    {
      row_id: 12,
      "Program Name": "Albuquerque Institute for Mathematics & Science (AIMS)",
      Organization: "PED - Magnet/Charter Schools",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "STEM Curriculums, Special STEM Schools or Magnet Programs, Career Pathways Programs/WBL",
      Age: "HS, Middle",
      "Curriculum Focus Area ": "STEM, Math, Technology",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged, Diversity",
      Overview: "AIMS specializes in a rigorous curriculum with a focus on STEM subjects such as advanced mathematics, sciences, and technology. It has consistently ranked highly for academic performance in the state.",
      Partners: "",
      Website: "https://www.aims-unm.org/"
    },
    {
      row_id: 13,
      "Program Name": "Alliance for Indigenous Math Circles (AIMC)",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Train the Trainers",
      "Type of Curriculum": "After-School STEM Programs, Teacher Training Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "Math",
      Location: "Tribal",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Tribal",
      Overview: "An organization dedicated to supporting the development of math circles and outreach programs specifically designed for Indigenous students and teachers, aiming to build a community around mathematics while respecting Indigenous culture and traditions; essentially, it works to create accessible mathematical opportunities for Indigenous youth by connecting them with mathematicians and educators within their communities",
      Partners: "",
      Website: "https://aimathcircles.org/about-us/#:~:text=Mission%20Statement:%20The%20mission%20of,students%20while%20respecting%20Indigenous%20culture."
    },
    {
      row_id: 14,
      "Program Name": "America Makes, the National Additive Manufacturing Innovation Institute",
      Organization: "FabLab",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Makerspace",
      Age: "Elementary, Middle, HS, College, Adult",
      "Curriculum Focus Area ": "Engineering, Technology",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Fab Lab Hub has partnered with the Santa Fe Business Incubator [SFBI], to expand the Archimedes makerspace into a Fab Lab in the Fab Lab Network that was founded at the MIT Center for Bits and Atoms.  We will be providing job shop services for 3D Printing, CNC machining, laser cutting and marking, vinyl cutting and CAD design.  Students who take our Digital Badge courses will be eligible to apply for paid internships in the job shop.",
      Partners: "America Makes, the National Additive Manufacturing Innovation Institute",
      Website: "https://fablabhub.org/"
    },
    {
      row_id: 15,
      "Program Name": "Applied Dynamics Initiative",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Robotics",
      Location: "Alamogordo",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "A STEAM + Entrepreneurship organization that delivers its robotics programming to students in an after-school setting. Funded Effort: To support both programmatic and operational related expenses for robotics tools, robot parts & equipment, special event fees, and competition travel.",
      Partners: "",
      Website: "https://applieddynamicsinitiative.org/",
      "Program Contact": "",
      Email: "",
      Phone: "(505) 225-8520"
    },
    {
      row_id: 16,
      "Program Name": "Artificial Intelligence Camp",
      Organization: "STEM Outreach Center",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "AI, Technology",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The Artificial Intelligence (AI) Camp, developed by MIT, features hands-on computer-based activities on AI concepts, ethical issues in AI, creative expression using AI, and how AI relates to campers\u2019 future.\nCampers will learn to recognize the AI you interact with daily, train and use machine learning to make predictions, investigate bias in machine learning applications, create novel works of art using AI",
      Partners: "New Mexico State University (NMSU)"
    },
    {
      row_id: 17,
      "Program Name": "ARTsmart",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs, Summer Camps and Bootcamps",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "Art",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "ARTsmart empowers and transforms lives by teacher art, literacy and life skills. ARTsmart ensures that Santa Fe and New Mexico youth have the opportunity to explore, experience, and engage in the visual arts, a critical component of every student\u2019s education. ARTclub-after school programs for elementary and middle schools.\nARTreach-during school visual art programming\nARTcamp-summer art camps\nVisiting Artist program-local artist bring their skills and talent into the schools.\nCollege scholarships for any high school senior entering into a visual art degree.",
      Partners: "",
      Website: "http://www.artfeast.com/",
      "Program Contact": "",
      Email: "speterson@artsmartnm.org"
    },
    {
      row_id: 18,
      "Program Name": "Asombro Institute for Science Education",
      Organization: "Asombro Institute for Science Education",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Provide curriculum and field trips for K-12",
      Partners: "",
      Website: "https://asombro.org/",
      "Program Contact": "Stephanie Bestelmeyer",
      Email: "stephanie@asombro.org"
    },
    {
      row_id: 19,
      "Program Name": "Atomic Museum STEM Camps",
      Organization: "Atomic Museum (New Mexico)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps, After-School STEM Programs",
      Age: "Elementary, Middle",
      "Curriculum Focus Area ": "Science, Physics",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "These camps are aimed at students of various ages and provide immersive, fun activities related to STEM topics. They include single-day camps where students can participate in interactive experiences like chemistry experiments, learning about physics, and even understanding electricity and magnetism through creative activities",
      Partners: "",
      Website: "https://www.atomicmuseum.vegas/education/"
    },
    {
      row_id: 20,
      "Program Name": "BE Pro Be Proud",
      Organization: "New Mexico Department of Workforce Solutions",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "Career Exploration virtual content",
      Age: "HS, Middle, Elementary",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "An initiative led by the New Mexico Department of Workforce Solutions and the New Mexico Center for Economic Opportunity. Be Pro Be Proud is a mobile workshop experience for students to discover which skilled professions spark their interests as they dig, drive, and weld using custom-developed, highly interactive Virtual Reality (VR) and Augmented Reality (AR) simulators.",
      Partners: "",
      Website: "https://beprobeproudnm.org/"
    },
    {
      row_id: 21,
      "Program Name": "Bio Tech at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Conservation, Biomedical/ Laboratory Research",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Would you like to create medicines, clean up pollutants, or protect crops from pests? These are just some of the work that you can do as a biotechnologist! Build biotech skills with scientists from UNM as you run experiments that control cells using engineered DNA! You could be starting your career in biotech!\n\nPresented in partnership with and with funding assistance from Lakin Labs of UNM."
    },
    {
      row_id: 22,
      "Program Name": "Blast Off 2.0!  at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary, Middle",
      "Curriculum Focus Area ": "Robotics, Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Calling all aspiring space explorers! Join our electrifying rocketry class where you\u2019ll design, build, and launch your own rockets. Delve into the thrilling realms of aerospace engineering and witness your creations soar toward the skies in an awe-inspiring adventure of space exploration."
    },
    {
      row_id: 23,
      "Program Name": "Boomerang New Mexico",
      Organization: "STEM Boomerang",
      "Program Support Mechanisms": "Industry Partnerships, Internships/WBL",
      "Type of Curriculum": "Professional Dev/Coaching, Career Exploration virtual content, Career Fairs, Industry-Sponsored Programs/Internships",
      Age: "College, Adult",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Workforce development org that helps faciliate the connection between students/professionals and NM employer via jobs and internships. Professional development courses",
      Partners: "",
      Website: "www.boomerang-nm.com"
    },
    {
      row_id: 24,
      "Program Name": "Boys & Girls Clubs of Farmington",
      Organization: "Boys & Girls Club",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Farmington",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Providing a safe, nurturing environment for youth aged 6-17, this organization offers fun, interactive activities that may include STEM-related programs."
    },
    {
      row_id: 25,
      "Program Name": "Career Pathways Program at Explora",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships, Internships/WBL",
      "Type of Curriculum": "After-School STEM Programs, Work-based Learning opportunities, Science Fairs/Tech showcases, Career Pathways Programs/WBL",
      Age: "HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Explora offers over 200 interactive Explorations programs, benchmarked to the New Mexico State educational standards, for schools, homeschool groups, libraries, and community centers. These programs also are offered for adults and seniors.\nEach year, Explora facilitates more than 2,200 programs for over 70,000 people from all 33 New Mexico counties and from the surrounding states. Programs take place at Explora, at community sites, or virtually and can be offered in both English and Spanish.X Studio at Explora is Explora\u2019s teen center where teens experiment, create, hang out, and learn.Explora\u2019s Career Pathways Internship (CPI) program offers high school juniors and seniors a gateway to move beyond economic limitations and into intellectually stimulating, personally rewarding employment in STEAM jobs that serve the community, contributes to Explora's educational mission, and leads to expanded educational and career opportunities. First Year: Juniors focus on workforce training and STEAM education under mentorship, gaining skills in classroom management and visitor engagement. Second Year: Seniors deepen STEAM knowledge, engage with professionals, and plan for future steps like higher education or certifications.",
      Partners: "Explora",
      Website: "https://www.explora.us/xstudio/"
    },
    {
      row_id: 26,
      "Program Name": "Career Technical Education (CTE)",
      Organization: "New Mexico Public Education Department (PED)",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "STEM Curriculums",
      Age: "HS",
      "Curriculum Focus Area ": "Technology, Engineering, Biomedical/ Laboratory Research, Healthcare, Math",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "CTE programs provide students with the academic and technical skills necessary for STEM careers, particularly through hands-on experiences in various industry sectors. These programs are aligned with state and industry standards and offer pathways in fields such as engineering, healthcare, and information technology\u200B",
      Partners: "",
      Website: "https://webnew.ped.state.nm.us/bureaus/college-career-readiness/career-technical-education/"
    },
    {
      row_id: 27,
      "Program Name": "Careers2Communities - Pathways2Careers",
      Organization: "New Mexico Public Education Department (PED)",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "STEM Curriculums, Career Pathways Programs/WBL",
      Age: "Middle",
      "Curriculum Focus Area ": "Math",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The Careers2Communities (C2C) program is designed to increase all New Mexico students\u2019 college and career readiness, ensuring that those students traditionally under-represented in higher education and the workplace can equitably achieve high-value careers. C2C is funded by the federal Expanding Access to Well-Rounded Courses Demonstration Grants Program, and is FREE for all New Mexico students and teachers.",
      Partners: "",
      Website: "https://webnew.ped.state.nm.us/bureaus/college-career-readiness/careers2communities-c2c/"
    },
    {
      row_id: 28,
      "Program Name": "Center for Teaching Excellence",
      Organization: "New Mexico Highlands University",
      "Program Support Mechanisms": "Train the Trainers",
      "Type of Curriculum": "Teacher Training Programs, Mentorship Programs for Educators",
      Age: "Educator",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The Center for Teaching Excellence serves the New Mexico Highlands University community by providing programming, resources and support for quality teaching and advising, and for the assessment of effective student learning. The center works in collaboration with existing professional development opportunities such as ARMAS and the Learning Communities to maximize resources and expand reach to more faculty. The primary goal is to help teachers help students be more successful. Teachers receiving training include faculty, adjuncts, GTAs and staff who teach.",
      Partners: "",
      Website: "http://cte.nmhu.edu/"
    },
    {
      row_id: 29,
      "Program Name": "City of Clovis Summer Youth Program",
      Organization: "City of Clovis",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Elementary",
      "Curriculum Focus Area ": "STEM",
      Location: "Clovis",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Although not exclusively STEM-focused, this program offers outdoor and educational activities for kids aged 5-11 during the summer, potentially incorporating STEM themes in some activities"
    },
    {
      row_id: 30,
      "Program Name": "Classified Ready Employee Workforce (CREW)",
      Organization: "New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Higher Ed , Industry Partnerships",
      "Type of Curriculum": "College-led STEM Outreach",
      Age: "College",
      "Curriculum Focus Area ": "Engineering",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The mission of the CREW program is to develop a diverse pool of classified-ready professionals with the necessary technical, professional, and interpersonal skills required to pursue successful careers in support of national security.",
      Partners: "New Mexico State University (NMSU)",
      Website: "https://psl.nmsu.edu/student-programs/crew-page.html",
      "Program Contact": "Marcella Shelby at  or 575-646-9201.",
      Email: "mshelby@psl.nmsu.edu"
    },
    {
      row_id: 31,
      "Program Name": "Club Atom",
      Organization: "Atomic Museum (New Mexico)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Nuclear Science",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "A more specialized program, Project Atom is a free out-of-school club aimed at middle and high school students with a focus on nuclear science. It covers topics such as nuclear energy, reactor safety, radiation, and historical nuclear events like Chernobyl and Fukushima. This program is ideal for students who want a deeper dive into nuclear science\u200B"
    },
    {
      row_id: 33,
      "Program Name": "CNM Maker Space",
      Organization: "Central New Mexico Community College (CNM)",
      "Program Support Mechanisms": "Higher Ed, Out of School Time (OST) Programs",
      "Type of Curriculum": "Makerspace",
      Age: "College, Adult",
      "Curriculum Focus Area ": "Technology",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "FUSE is part of Albuquerque\u2019s Innovation District, which is focused on stimulating creative thinking and economic growth in Albuquerque and the surrounding areas. Members have access to a wide variety of manual and digital fabrication equipment that they can use to design, prototype, and create manufactured works. FUSE serves the entire community \u2013 not just CNM students.",
      Partners: "CNM Ingenuity",
      Website: "https://www.cnm.edu/locations/fuse-makerspace",
      "Program Contact": "",
      Email: "",
      Phone: "Phone: (505) 224-3000"
    },
    {
      row_id: 34,
      "Program Name": "College Horizons",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Career Pathways Programs/WBL, Professional Dev/Coaching",
      Age: "HS, College",
      "Curriculum Focus Area ": "STEM",
      Location: "Tribal",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Tribal",
      Overview: "To increase the higher education of Native American students by providing pre-college (College Horizons) and pre-graduate (Graduate Horizons) programs, as well as a follow-up retention program, to American Indian, Alaska Native, and Native Hawaiian high school and college students/graduates.",
      Partners: "",
      Website: "http://www.collegehorizons.org/",
      "Program Contact": "",
      Email: "info@collegehorizons.org"
    },
    {
      row_id: 35,
      "Program Name": "Communities to Careers",
      Organization: "University of New Mexico (UNM) Health Sciences",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed ",
      "Type of Curriculum": "After-School STEM Programs, Summer Camps and Bootcamps, College-led STEM Outreach, Career Fairs",
      Age: "Elementary, College",
      "Curriculum Focus Area ": "Healthcare, Biomedical/ Laboratory Research",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Tribal, Disadvantaged",
      Overview: "Communities to Careers is growing NM\u2019s diverse health care workforce by offering a series of 12, K-20+ focused programs serving 45 locations in NM and Tribal Nations. From after school health career exploration programs in partnership with schools, to health professions preparation summer programs, we work IN communities, WITH communities to support students\u2019 health care career goals. ",
      Partners: "",
      Website: "https://goto.unm.edu/diversity-programs",
      "Program Contact": "Amy Greene",
      Email: "amkgreene@salud.unm.edu"
    },
    {
      row_id: 36,
      "Program Name": "Computer Science Alliance",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Train the Trainers, K- 12 Public education (In school time)",
      "Type of Curriculum": "STEM Curriculums, Teacher Training Programs, Mentorship Programs for Educators",
      Age: "Middle, HS, Elementary",
      "Curriculum Focus Area ": "Technology, AI, Coding/CS",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "We are an education hub for computer science and computational thinking. We work to empower educators & schools with the needed tools for computational curriculum, and we leverage industry alliances with a vision for a future technical workforce.",
      Partners: "",
      Website: "https://computersciencealliance.org/"
    },
    {
      row_id: 38,
      "Program Name": "COSMIAC Student Support",
      Organization: "University of New Mexico (UNM)",
      "Program Support Mechanisms": "Higher Ed, Industry Partnerships, Internships/WBL",
      "Type of Curriculum": "Work-based Learning opportunities, Dual Credit/CTE (STEM)",
      Age: "College",
      "Curriculum Focus Area ": "Space, Physics, Science, Nuclear Science",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "COSMIAC, a research center under the School of Engineering at UNM, supports many undergraduate, Masters, and PhD seeking students. When on contract, these students perform duties according to their specified training, education, and expertise. A student must be registered for courses in order to be eligible for employment. During the summer session, students do not have to take courses. However, if a student is not taking courses during the summer session, that student must be registered for the following Fall semester.",
      Partners: "The University of New Mexico (UNM)"
    },
    {
      row_id: 39,
      "Program Name": "Creative Robotics at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps, After-School STEM Programs",
      Age: "Elementary",
      "Curriculum Focus Area ": "Robotics",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Writing basic computer programs as a creative exercise helps to develop analytical skills, problem-solving and logical thinking. By exploring MSW Logo, students will design and test objects in simulated motion and learn applications of simple coordinate geometry."
    },
    {
      row_id: 40,
      "Program Name": "Cruces Creatives",
      Organization: "",
      "Program Support Mechanisms": "Industry Partnerships",
      "Type of Curriculum": "Makerspace",
      Age: "Elementary, Middle, HS, College, Adult, Pre-K",
      "Curriculum Focus Area ": "STEM, Technology, Robotics, Math",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Makerspace that connects people with the tools, training, and community to make practically anything--and that uses the tools and skill sets gathered at the makerspace to launch interdisciplinary charitable projects.\nTools and space include 3D printers, CAD manufacturing tools such as CNC and laser, wood shop, bicycle shop, textile lab, audio-visual lab, electronics lab, kids room, and more.",
      Partners: "Cruces Creatives",
      Website: "https://crucescreatives.org/",
      "Program Contact": "",
      Email: "Lea Wise-Surguy -Board chair, Co-Founder",
      Phone: "Office: (575) 448-1072 OR Email: Support@crucescreatives.org/STREAM@crucescreatives.org."
    },
    {
      row_id: 41,
      "Program Name": "CtREX Career Preperation Program",
      Organization: "University of New Mexico (UNM) Health Sciences Center",
      "Program Support Mechanisms": "Internships/WBL, Higher Ed",
      "Type of Curriculum": "Industry-Sponsored Programs/Internships",
      Age: "College",
      "Curriculum Focus Area ": "Healthcare, Biomedical/ Laboratory Research",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "UNM\u2019s Clinical & Translational Research Experience (CT-REx) Program is a career preparation program for undergraduate students who are interested in exploring careers as clinical research professionals. Clinical research professionals (CRPs) support academic medical research and include job titles such as research coordinators and data management specialists. CT-REx trainees participate in a 8-week summer program, 40 hours per week. The program provides skill-based training, mentorship, and hands-on learning in the key areas of research",
      Partners: "",
      Website: "",
      "Program Contact": "",
      Email: "ctrex@salud.unm.edu"
    },
    {
      row_id: 42,
      "Program Name": "Cultivating Coders",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "Science Fairs/Tech showcases, Competitions and Challenges, After-School STEM Programs, Summer Camps and Bootcamps",
      Age: "Elementary, Middle, HS, Adult",
      "Curriculum Focus Area ": "Coding/CS",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Rural, Disadvantaged, Tribal",
      Overview: "We bring specialized tech programs to young adults and K-12 schools in rural, tribal & underserved inner cities. #TechInclusion #CS4All #CyberSecurity",
      Partners: "Cultivating Coders",
      Website: "https://cultivatecoders.com/"
    },
    {
      row_id: 43,
      "Program Name": "Discovery Labs: Aero-Ventures ",
      Organization: "STEM Outreach Center",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Middle",
      "Curriculum Focus Area ": "Space, Engineering",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Explore exciting concepts in aeronautics and aerospace engineering. Study how flight works by getting hands-on building, testing, and redesigning gliders, darts, and rockets. Think critically and creatively about where this industry could go as you take on engineering design challenges and explore aeronautics, aviation, and aerospace careers.",
      Partners: "New Mexico State University (NMSU)"
    },
    {
      row_id: 44,
      "Program Name": "Diverse IT",
      Organization: "Adelante, PED Magnet Schools",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Internships/WBL, K- 12 Public education (In school time)",
      "Type of Curriculum": "After-School STEM Programs, Work-based Learning opportunities",
      Age: "HS",
      "Curriculum Focus Area ": "Technology",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged",
      Overview: "GoogleIT Certificate course for high school students to gain skills and experience for jobs.",
      Partners: "Adelante"
    },
    {
      row_id: 45,
      "Program Name": "DoD STARBASE NM",
      Organization: "Air Force Research Lab (AFRL)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs, Summer Camps and Bootcamps",
      Age: "Elementary",
      "Curriculum Focus Area ": "Engineering, Space, Technology, Math",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Students complete hands-on, minds-on activities while participating in a national program that provides opportunities to explore engineering, math operations and applications, physics, chemistry, technology, and STEM careers.\n\n5th grade\n25 hours of curriculum \n25 contact hours \nMission is conducted at the AFRL NM STEM Academy\nTeacher orientation provided\nFive 5-hour classes",
      Partners: "",
      Website: "https://afrlnm.com/stem/",
      "Program Contact": "",
      Email: "stem@afrlnewmexico.com"
    },
    {
      row_id: 46,
      "Program Name": "DOE Regional Science Bowl \u2013 New Mexico - Sandia National Labs",
      Organization: "Sandia National Labs",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Competitions and Challenges",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Technology, Math",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged",
      Overview: "These programs focus on underrepresented youth, particularly in low-income areas, and aim to break down barriers to career development. They also work to expand these internship opportunities into rural New Mexico, where access can be limited"
    },
    {
      row_id: 47,
      "Program Name": "Early College Academy (ECA) / College & Career High School",
      Organization: "PED - Magnet/Charter Schools",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "Special STEM Schools or Magnet Programs",
      Age: "HS",
      "Curriculum Focus Area ": "Computer Science, Engineering, Healthcare",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "ECA allows students to earn college credits while in high school with a focus on STEM-related fields, especially computer science, engineering, and healthcare.",
      Partners: "",
      Website: "https://cec.aps.edu/"
    },
    {
      row_id: 48,
      "Program Name": "Emerging Issues in Cybersecurity REU",
      Organization: "New Mexico Institute for Mining and Technology (NMTech) Joint: Computer Sciences and The New Mexico Cybersecurity Center of Excellence of New Mexico",
      "Program Support Mechanisms": "Higher Ed , Internships/WBL",
      "Type of Curriculum": "College-led STEM Outreach, Work-based Learning opportunities",
      Age: "College",
      "Curriculum Focus Area ": "Technology",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The site of Research Experiences for Undergraduates \u2013 Emerging Issues in Cybersecurity is funded by NSF CISE which offers a ten-week summer research experience to a diverse group of undergraduate students. The site is hosted jointly by the Department of Computer Science and The New Mexico Cybersecurity Center of Excellence of New Mexico Institute of Mining and Technology (New Mexico Tech). The 2023 program will be from Monday, May 22 to Saturday, July 29.\n\nThe goals of this REU site include providing students with experience in cutting-edge research in cybersecurity, broadening participation in computing, motivating students to pursue graduate studies in computer science, and preparing the future cybersecurity workforce.",
      Partners: "",
      Website: "https://www.cs.nmt.edu/research/reu-intro/"
    },
    {
      row_id: 49,
      "Program Name": "Engineering the Future",
      Organization: "Magnet School - PED, Albuquerque Public Schools (APS)",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "Special STEM Schools or Magnet Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Magnet schools (3)  through APS (Elementary, Mid, High) that focus on Engineer career paths.  \nGives students opportunities for internships with local STEM companies\nEncourages creativity, innovation, resourcefulness and resilience\nEquips students with strong skills in coding, public speaking and collaborating in teams",
      Partners: "",
      Website: "https://www.aps.edu/innovation/engineering-the-future"
    },
    {
      row_id: 50,
      "Program Name": "Engineering the Future - Valley High School ",
      Organization: "PED - Magnet/Charter Schools",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "Special STEM Schools or Magnet Programs",
      Age: "HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Engineering the Future (EtF) at Valley High School is part of a K-12 dedicated STEM Magnet pathway open to all students in Albuquerque Public Schools",
      Partners: "",
      Website: "https://valley.aps.edu/programs/engineering-the-future"
    },
    {
      row_id: 51,
      "Program Name": "Equip Academy of New Mexico ",
      Organization: "Equip Academy of New Mexico ",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Train the Trainers",
      "Type of Curriculum": "Career Pathways Programs/WBL, STEM Curriculums, After-School STEM Programs, Summer Camps and Bootcamps, Teacher Training Programs, Science Fairs/Tech showcases, Professional Dev/Coaching",
      Age: "Elementary, Pre-K",
      "Curriculum Focus Area ": "Math, STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Equip is a top-tier K-5 free public charter school on the Westside. Accepting enrollment forms for grades K and 1st for the 2025-26 school year!",
      Partners: "",
      Website: "EquipNM.org",
      "Program Contact": "Mercy Herrera ",
      Email: "mercy.herrera@equipnm.org"
    },
    {
      row_id: 52,
      "Program Name": "Expanding Computing Education Pathways (ECEP) in New Mexico",
      Organization: "",
      "Program Support Mechanisms": "Train the Trainers",
      "Type of Curriculum": "Teacher Training Programs, Mentorship Programs for Educators",
      Age: "Elementary, Middle, HS, College",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged, Diversity, Tribal",
      Overview: "The mission of ECEP is to broaden participation in computing by identifying and addressing the policies, pathways, and practices in state education systems that are barriers to diverse student engagement and success. ECEP state leaders believe that improving equitable capacity for, access to, participation in, and experiences of CS education will increase the number and diversity of students in computing and computing-intensive degree pathways in their states."
    },
    {
      row_id: 53,
      "Program Name": "Explore the Possiblities Seminar Series",
      Organization: "New Mexico Network for Women in Science and Engineering",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Science Fairs/Tech showcases",
      Age: "HS",
      "Curriculum Focus Area ": "Engineering, Science",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Female",
      Overview: "Career exploration and programming for youth women and science students",
      Partners: "",
      Website: "https://nmnwse.org/what-we-do/our-programs/",
      "Program Contact": "",
      Email: "NMNWSE_Board-L@list.unm.edu"
    },
    {
      row_id: 55,
      "Program Name": "Future City NM Competition ",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Competitions and Challenges",
      Age: "Middle",
      "Curriculum Focus Area ": "Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The Future City Competition is a non-profit national competition sponsored by the engineering community to promote technological literacy and engineering to middle school students. Students also learn life skills such as problem solving, teamwork, research, written and verbal communication, computer literacy, and gain an increased awareness of community related issues.",
      Partners: "",
      Website: "https://futurecitynm.org/",
      "Program Contact": "",
      Email: "newmexico@futurecity.org"
    },
    {
      row_id: 56,
      "Program Name": "GEAR UP (Gaining Early Awareness and Readiness in Undergraduate Programs)",
      Organization: "New Mexico Higher Education Department",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "Summer Camps and Bootcamps, Professional Dev/Coaching",
      Age: "HS, Middle",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "GEAR UP New Mexico, a division of the New Mexico Higher Education Department, is a federally funded program that aims to increase college and career readiness for middle school and high school students. GEAR UP New Mexico partners with seven school districts in the state that serve a high proportion\xAD\xAD of rural and first-generation students. The U.S. Department of Education renewed funding for the program in 2020 at $31.4 million for the next seven years to support approximately 7,000 students and their families each year.",
      Partners: "FOCUS",
      Website: "https://gearupnewmexico.org/college-and-career-readiness/"
    },
    {
      row_id: 57,
      "Program Name": "GeneLab for High Schools (GL4HS)",
      Organization: "NASA",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "After-School STEM Programs, Career Exploration virtual content",
      Age: "HS",
      "Curriculum Focus Area ": "Space",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "GeneLab for High Schools (GL4HS) is expanding its program in 2025! Starting this year GL4HS is being offered asynchronously and will consist of 12-weeks of on-demand training during the summer. Virtual and self-paced",
      Partners: "",
      Website: "https://www.nasa.gov/ames/genelab-for-high-schools/",
      "Program Contact": "",
      Email: "arc-gl4hs@mail.nasa.gov"
    },
    {
      row_id: 58,
      "Program Name": "Girls Inc. of Santa Fe",
      Organization: "Santa Fe Community Foundation",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps, After-School STEM Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Female, Disadvantaged",
      Overview: "Girls Inc. of Santa Fe is a nonprofit organization dedicated to empowering girls from ages 5 to 18 through programs that promote leadership, confidence, and academic achievement, particularly in areas like STEM, arts, and advocacy. Their mission is to inspire all girls to be strong, smart, and bold by providing them with the tools and support they need to navigate economic, social, and gender barriers. STEM & Academic Enrichment: Girls Inc. offers a variety of programs aimed at fostering interest in science, technology, engineering, and math (STEM). Girls participate in hands-on projects, coding workshops, and science experiments, which encourage curiosity and problem-solving skills.",
      Partners: "Girls Inc. of Santa Fe",
      Website: "https://www.santafecf.org/news-stories/girls-inc-of-santa-fe?gad_source=1&gclid=Cj0KCQjwmOm3BhC8ARIsAOSbapUg43ukGTg501LxmmIW_Ku-PXvEdpuqj6CzJfqHVUWMuVCaNgFyQlIaAuZnEALw_wcB"
    },
    {
      row_id: 59,
      "Program Name": "Governor\u2019s STEM Challenge",
      Organization: "New Mexico Public Education Department (PED)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Competitions and Challenges",
      Age: "HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "This program brings together high school students and industry partners to solve real-world problems. Teams work on challenges related to science, technology, engineering, and mathematics, with a focus on innovation and practical solutions\u200B"
    },
    {
      row_id: 60,
      "Program Name": "Hispanic Youth Research & Leadership Program",
      Organization: "The University of New Mexico (UNM)",
      "Program Support Mechanisms": "Higher Ed, Internships/WBL, Industry Partnerships",
      "Type of Curriculum": "Summer Camps and Bootcamps, Work-based Learning opportunities",
      Age: "HS",
      "Curriculum Focus Area ": "Biomedical/ Laboratory Research",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "This FREE program will allow participants to get a taste of college life, develop an understanding of the complex skills gained in research, and gain information on opportunities available through the STEM field. Participants will be assigned to groups. In these groups they will be working on a research project during this 5 day camp, ending with a research presentation for professional staff and families of student participants.",
      Partners: "The University of New Mexico (UNM)",
      Website: "https://cpp.unm.edu/hispanic-youth-research--leadership-program-/index.html",
      "Program Contact": "",
      Email: "unmcpp@unm.edu ",
      Phone: "Phone: (505) 277-5321"
    },
    {
      row_id: 61,
      "Program Name": "HMTech",
      Organization: "Sandia National Labs",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "STEM, Space, Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "HMTech is a summer STEM program provided by the Black Leadership Committee for middle and high school students. The program gets students involved in fun, hands-on, science and engineering activities and provides an opportunity to explore a variety of STEM careers.",
      Partners: "Black leadership Committee",
      Website: "https://www.sandia.gov/hmtech/",
      "Program Contact": "",
      Email: "blc-hmtech@sandia.gov"
    },
    {
      row_id: 62,
      "Program Name": "Innovation Zone Initative - Future Focus Education",
      Organization: "New Mexico Public Education Department (PED)",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Internships/WBL, Out of School Time (OST) Programs",
      "Type of Curriculum": "Work-based Learning opportunities, STEM Curriculums, Special STEM Schools or Magnet Programs, Career Pathways Programs/WBL",
      Age: "HS, College",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The College and Career Readiness Bureau (CCRB) administers competitive funding to support schools in their efforts to transform the high school experience. This involves creating a distinctive graduate profile that reflects the needs of the local community, the implementation of work-based learning, career technical education (CTE), capstone projects, social and emotional learning (SEL), and other programs aligned with core academics aimed at preparing students for future success in innovative and impactful ways."
    },
    {
      row_id: 63,
      "Program Name": "Institute for Computing in Research",
      Organization: "Institute for Computing in Research",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Internships/WBL, Industry Partnerships, Train the Trainers",
      "Type of Curriculum": "After-School STEM Programs, Summer Camps and Bootcamps, Industry-Sponsored Programs/Internships, Work-based Learning opportunities, Internship/Apprenticeship, Teacher Training Programs",
      Age: "Middle, HS, Educator",
      "Curriculum Focus Area ": "Coding/CS, Technology",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "We train students in the areas needed to be ready for research (computer programming, mathematics, critical thinking).  At the end of this educational pipeline we offer to pay them to spend summers doing research.",
      Partners: "",
      Website: "https://computinginresearch.org/",
      "Program Contact": "Mark Galassi",
      Email: "mark@galassi.org"
    },
    {
      row_id: 64,
      "Program Name": "Intro to Engineering at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "HS",
      "Curriculum Focus Area ": "Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "What in the world is engineering?  Almost everyone has heard of Mechanical and Computer Engineering, but what are Materials, Mineral, Chemical, and Environmental Engineering? Join New Mexico Tech for hands-on explorations of these five areas of engineering, learning real-world applications of these disciplines and why they are important to civilization. \n\nOffered in Collaboration with NM Tech Materials and Metallurgical Engineering"
    },
    {
      row_id: 65,
      "Program Name": "Jobs for America's Graduates, Inc",
      Organization: "",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "STEM Curriculums, Career Pathways Programs/WBL, After-School STEM Programs, Dual Credit/CTE (STEM), Professional Dev/Coaching",
      Age: "HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged",
      Overview: "The mission of Jobs for America's Graduates-NM is to provide educational products and services to at-risk New Mexico youth and other populations for the purpose of helping them to obtain a high school diploma or its equivalent, to attain employability skills, to transition into the workplace and higher education, and to secure a quality job with the opportunity for career advancement.",
      Partners: "",
      Website: "",
      "Program Contact": "",
      Email: "kay@jagnm.org"
    },
    {
      row_id: 66,
      "Program Name": "Justice Code",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs, Summer Camps and Bootcamps, Competitions and Challenges",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged",
      Overview: "Creating opportunities for K-12 students in New Mexico to partner with students globally as they perfect skills in STEAM-L (Science, Technology, Engineering, Digital Art, Math, and Language) through critical thinking, creativity, collaboration, and communication.",
      Partners: "",
      Website: "https://www.justicecode.org/",
      "Program Contact": "",
      Email: "justicecodecommunity@gmail.com"
    },
    {
      row_id: 67,
      "Program Name": "LANL Scholars",
      Organization: "Los Alamos National Labs Foundation",
      "Program Support Mechanisms": "Internships/WBL, Industry Partnerships",
      "Type of Curriculum": "Work-based Learning opportunities",
      Age: "College",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Summer Internship program and professional development and mentoring program",
      Partners: "",
      Website: "https://lanlscholars.org/",
      "Program Contact": "",
      Email: "silvia@lanlfoundation.org"
    },
    {
      row_id: 68,
      "Program Name": "Learning Games Lab - Fall Think Tanks",
      Organization: "New Mexico State University (NMSU) - College of ACES (Agriculture, Consumer, and Enviromental Sciences)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps, After-School STEM Programs",
      Age: "HS",
      "Curriculum Focus Area ": "Coding/CS",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Do you like games and media, or do you know someone who does? Become a Games Lab consultant during one of our Think Tank Sessions. Attendees will play and evaluate various games and other interactive experiences like VR. Consultants will learn how to create games, engage in hands-on design activities, and provide feedback to games under development, interacting with professional developers, programmers, and artists.",
      Partners: "New Mexico State University (NMSU) - College of ACES (Agriculture, Consumer, and Enviromental Sciences)",
      Website: "https://innovativemedia.nmsu.edu/think-tanks.html",
      "Program Contact": "Matheus Cezarotto",
      Email: "matheus@nmsu.edu",
      Phone: "575-646-5284",
      "Link to Apply": "https://acesnmsu.az1.qualtrics.com/jfe/form/SV_ba8fPmvk8Ta2Soe"
    },
    {
      row_id: 69,
      "Program Name": "Making Friends with the M in STEM",
      Organization: "STEM SF",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Science Fairs/Tech showcases",
      Age: "Middle",
      "Curriculum Focus Area ": "Math",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "STEM Santa Fe is proud to have brought for the first time in New Mexico the Julia Robinson Mathematics Festival in Santa Fe. This Festival is meant to inspire students to explore the richness and beauty of mathematics through activities that encourage collaborative, creative problem-solving. The Festival introduces kids to the beauty of mathematics by providing interesting, inspiring, engaging, and thought-provoking problems.",
      Partners: "",
      Website: "https://sharenm.org/stem-santa-fe/making-friends-with-the-m-in-stem-programs"
    },
    {
      row_id: 70,
      "Program Name": "Math Amigos Family Math Night",
      Organization: "Math Amigos",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary",
      "Curriculum Focus Area ": "Math",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Math Events for Students: Math Amigos also organizes events like Family Math Nights and Math Circles, where students and their families participate in fun, interactive math activities. These events are designed to make math more accessible and enjoyable for students, promoting a positive attitude toward the subject",
      Partners: "",
      Website: "https://mathamigos.org/"
    },
    {
      row_id: 71,
      "Program Name": "Math Amigos Teacher Professional Development Workshop",
      Organization: "Math Amigos",
      "Program Support Mechanisms": "Train the Trainers",
      "Type of Curriculum": "Teacher Training Programs",
      Age: "Elementary",
      "Curriculum Focus Area ": "Math",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Math Amigos is a nonprofit organization based in Santa Fe, New Mexico, aimed at improving math education in elementary schools. The program works primarily with public schools in Santa Fe and surrounding areas, offering professional development for teachers, support for classroom instruction, and engaging math activities for students to boost proficiency and enthusiasm for mathematics. Teacher Professional Development: Math Amigos focuses on enhancing teachers' instructional skills in mathematics through workshops, coaching, and providing resources aligned with best practices in math education. This ensures teachers are well-equipped to deliver effective, engaging math lessons.",
      Partners: "",
      Website: "https://mathamigos.org/"
    },
    {
      row_id: 72,
      "Program Name": "MindfulBytes.io",
      Organization: "Merek Security Solutions",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Industry Partnerships",
      "Type of Curriculum": "STEM Curriculums",
      Age: "Elementary",
      "Curriculum Focus Area ": "Technology",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "MindfulBytes.io is an initiative by the Center for Cybersecurity and Cyberpsychology Research, a division of Merek Security Solutions, dedicated to empowering children in grades K-5 to become responsible and mindful digital citizens.\u200B\u200B \u200B\u200BBy integrating cybersecurity education with mindfulness practices, MindfulBytes.io addresses the cognitive, social, and emotional aspects of children's online experiences.\u200B\u200B \u200B\u200B",
      Partners: "",
      Website: "https://www.mindfulbytes.io",
      "Program Contact": "Michael Davis",
      Email: "michael@merek.io"
    },
    {
      row_id: 73,
      "Program Name": "Mission Achievement and Success Charter School",
      Organization: "PED - Magnet/Charter Schools",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "Special STEM Schools or Magnet Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "This public charter school emphasizes college readiness through a rigorous STEM curriculum for its students, with a strong focus on mathematics and sciences.",
      Partners: "",
      Website: "https://www.missionachievementandsuccess.com/"
    },
    {
      row_id: 74,
      "Program Name": "Mission Concept (MC) through University NanoSatellite Program",
      Organization: "Air Force Research Labs (AFRL), NASA",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "College",
      "Curriculum Focus Area ": "Space",
      Location: "Kirtland Air Force Base",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The University Nanosatellite Program (UNP) funds U.S. university students and programs to design, build, launch, and operate small satellites. UNP is funded by the Air Force Office of Scientific Research (AFOSR) and managed from the Air Force Research Laboratory\u2019s (AFRL) Space Vehicles Directorate (RV) located on Kirtland Air Force Base, NM.  In 2023, the Mission Concept (MC) program was added to UNP through a partnership with NASA\u2019s CubeSat Launch Initiative (CSLI) and Exploration Research & Technology (ER&T). All three organizations found universities applying to our programs for the first time often had non-competitive applications and concepts. The MC program was created to help these new universities access mentoring and guidance in scoping a relevant mission. UNP expects that as these participants learn and grow, the pool of more mature applicants will also expand.",
      Partners: "",
      Website: "https://universitynanosat.org/",
      "Program Contact": "Lee Jasper",
      Email: "Lee.Jasper@sdl.usu.edu"
    },
    {
      row_id: 75,
      "Program Name": "Nano Science at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "HS",
      "Curriculum Focus Area ": "Technology, Science",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Come explore the science of the super small. Nanometer-sized objects are too small even for ordinary microscopes to see them! Investigate how scientists work with items too small to see, explore products that use nanotechnology, and discover how nanotechnology can give ordinary materials special properties.\n\nPresented in partnership with the Cavallo Research Group at the University of New Mexico (UNM) with support from the National Science Foundation (Award No. 2144944)"
    },
    {
      row_id: 76,
      "Program Name": "Native American programs",
      Organization: "STEM SF",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle",
      "Curriculum Focus Area ": "Technology, Engineering",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Tribal",
      Overview: " STEM Santa Fe runs programs that support Native American students through culturally relevant, hands-on STEM education, especially focusing on underrepresented groups. Their initiatives include mentorships, community-driven projects, and exposure to STEM fields through real-world applications. For example, STEM Santa Fe collaborated with students from the Santa Fe Indian School on a Laser Harp project. This multidisciplinary program combined music, art, and engineering, with students using lasers and an Arduino electronics board to create a musical instrument. The project emphasizes both creativity and STEM learning while reflecting Native American culture."
    },
    {
      row_id: 77,
      "Program Name": "New Mexico Botball Tournament",
      Organization: "KISS Institute for Practical Robotics ",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "STEM Curriculums",
      Age: "Elementary",
      "Curriculum Focus Area ": "Robotics",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Autonomous Robotics competition focused on students learning how to write text-based computer code.",
      Partners: "",
      Website: "botball.org",
      "Program Contact": "Steve Goodgame",
      Email: "sgoodgame@kirp.org"
    },
    {
      row_id: 78,
      "Program Name": "New Mexico Mathematics, Engineering, and Science Achievement (MESA)",
      Organization: "New Mexico Mathematics, Engineering, and Science Achievement",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Competitions and Challenges, Summer Camps and Bootcamps, After-School STEM Programs",
      Age: "HS",
      "Curriculum Focus Area ": "Math, Science, Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "New Mexico Mathematics, Engineering, and Science Achievement is a pre-college program that prepares students for college and careers in mathematics, engineering, science or technically related fields. MESA students participate in a variety of enriched math, science and engineering activities including field trips, speakers, workshops, regional and statewide academic competitions, community service and leadership development projects. NM MESA provides funding and logistical support for these and other activities.",
      Partners: "",
      Website: "https://www.nmmesa.org/",
      "Program Contact": "",
      Email: "",
      Phone: "505-366-2500 "
    },
    {
      row_id: 79,
      "Program Name": "New Mexico Middle School Electric Car Challenge - Sandia National Labs",
      Organization: "Sandia National Labs",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Competitions and Challenges",
      Age: "Middle",
      "Curriculum Focus Area ": "Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Another related program, X3 NeXt, extends these opportunities to students who have already earned a high school diploma or GED, helping them pursue further education through certificates or college degrees, while continuing their work experience."
    },
    {
      row_id: 80,
      "Program Name": "New Mexico Partnership for Math and Science Education",
      Organization: "",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Train the Trainers",
      "Type of Curriculum": "STEM Curriculums, Teacher Training Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "Science, Math",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Our vision: To promote coherence and quality of STEM education initiatives through dissemination of information, networking, coordination, and collaboration so that New Mexico will become a leader in STEM education.",
      Partners: "New Mexico Partnership for Math and Science Education",
      Website: "https://nmpmse.org/index.php/about-us/"
    },
    {
      row_id: 81,
      "Program Name": "New Mexico Space Grant Consortium (NMSGC)",
      Organization: "New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Train the Trainers, Higher Ed, Industry Partnerships",
      "Type of Curriculum": "Competitions and Challenges, After-School STEM Programs, Teacher Training Programs, Mentorship Programs for Educators, College-led STEM Outreach, Industry-focused curriculum/training",
      Age: "Elementary, Middle, HS, Educator, College",
      "Curriculum Focus Area ": "Space",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The NMSGC works to inspire students in aerospace and STEM careers by offering educational opportunities, competitions, and scholarships.",
      Partners: "",
      Website: "https://nmspacegrant.nmsu.edu/"
    },
    {
      row_id: 82,
      "Program Name": "New Mexico Summer Enrichment Internship Program",
      Organization: "New Mexico Public Education Department (PED)",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Industry Partnerships, Internships/WBL",
      "Type of Curriculum": "Work-based Learning opportunities",
      Age: "HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "HS students with internships in local and state muncipalities",
      Partners: "",
      Website: "https://www.nminterns.com/contact.html"
    },
    {
      row_id: 83,
      "Program Name": "NM STEM Academy",
      Organization: "Air Force Research Lab (AFRL)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "Space, Robotics",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "We provide structured \u201CMissions\u201D during the school year that provide opportunities for students in 5th \u2013 12th grades to explore a variety of STEM concepts:\n\nMission to Mars\n\nDoD STARBASE NM\n\nDoD STARBASE Advanced\n\nTech Mission\n\nRobotics Challenge\n\nSTEM Challenge",
      Partners: "",
      Website: "https://afrlnm.com/stem/",
      "Program Contact": "Ronda Cole",
      Email: "ronda@afrlnewmexico.com"
    },
    {
      row_id: 84,
      "Program Name": "PreK-12 STEM Education",
      Organization: "Project ECHO for Education",
      "Program Support Mechanisms": "Train the Trainers",
      "Type of Curriculum": "Mentorship Programs for Educators, Teacher Training Programs",
      Age: "Educator",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Project ECHO for Education is designed to create a learning network where teachers from across New Mexico have the opportunity to help their students graduate from high school by: Accessing and share best practices;\nReceiving professional development from experts; and\nBenefiting from collaborative problem-solving about New Mexico\u2019s school systems and its learners."
    },
    {
      row_id: 85,
      "Program Name": "Quantum Computing, Mathematics & Physics (QCaMP) ",
      Organization: "Sandia National Labs",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Train the Trainers, Industry Partnerships",
      "Type of Curriculum": "After-School STEM Programs, Teacher Training Programs",
      Age: "HS, Educator",
      "Curriculum Focus Area ": "Math, Physics, Coding/CS",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Join us for a week-long summer camp for STEM teachers (June 5-9) and students (June 26-30), during which you will get a primer on the fundamentals of computing, learn hands-on the oftentimes perplexing phenomena of quantum physics, and apply those phenomena to solve computing problems in new ways.",
      Partners: "Sandia National Labs",
      Website: "https://www.sandia.gov/quantum/qcamp/",
      "Program Contact": "Megan Ivory",
      Email: "mkivory@sandia.gov"
    },
    {
      row_id: 86,
      "Program Name": "Raspberry Pi\xAE at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle",
      "Curriculum Focus Area ": "Coding/CS",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Learn real programming skills as you discover the ins and outs of a Raspberry Pi\xAE, a computer the size of a credit card that you get to take home!"
    },
    {
      row_id: 87,
      "Program Name": "Renewable Energy at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary, Middle",
      "Curriculum Focus Area ": "Technology",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Join is for an unforgettable journey into the realm of renewable energy and contribute to a cleaner and brighter tomorrow! This transformative experience offers hands-on learning and exploration of various renewable resources. Campers will engage in exciting experiments, gain insights into water power, and discover the vital role it plays in shaping a greener and more sustainable future.\n\nOffered in Collaboration with the Sandia National Laboratories Water Power Organization"
    },
    {
      row_id: 88,
      "Program Name": "Robotics Challenge",
      Organization: "Air Force Research Lab (AFRL)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "Competitions and Challenges",
      Age: "Middle",
      "Curriculum Focus Area ": "Robotics, Coding/CS",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Students work in teams to explore the basics of robotics and coding. Teams complete assignments that they submit online to earn points. The top 30 teams, based on points earned, qualify to participate in the annual Robotics Challenge Expo.\n\n6th \u2013 8th grade\n15+ hours of curriculum \n4+ contact hours \nMission is school based\nTeacher training, materials, and online curriculum provided\nCulminating event in April / May for qualifying teams",
      Partners: "",
      Website: "https://afrlnm.com/stem/missions/robotics-challenge/",
      "Program Contact": "",
      Email: "stem@afrlnewmexico.com"
    },
    {
      row_id: 89,
      "Program Name": "Robotics Training Institute",
      Organization: "R4 Creating",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs, Competitions and Challenges",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "Coding/CS, Robotics",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Award winning STEAM programs for kids ages 6-18. Join other students in learning the power of STEM, teamwork and working hard! Teams work together to build, program and compete in robotics competitions, learning every step of the way! To learn more and get involved, sign up below. This program is designed for the student that is interested in beginning in Robotics and doesn't have time to commit to Competitions that will take an entire day.Class time:Thursdays: 5:30PM - 7:00PM",
      Partners: "R4 Creating",
      Website: "https://www.r4creating.org/",
      "Program Contact": "Shelley Grunig",
      Email: "Info@R4creating.org ",
      Phone: "505-715-7732"
    },
    {
      row_id: 90,
      "Program Name": "Rocketeer Academy",
      Organization: "New Mexico Museum of Space History",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary",
      "Curriculum Focus Area ": "Space",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Want to be a rocket scientist? Or just know what they do? New Mexico Rocketeer Academy has something for the young astronaut in each of us, whether it\u2019s week-long summer camps or education programs held here at the museum or in your class. 7+",
      Partners: "",
      Website: "https://www.newmexicoculture.org/museums/new-mexico-museum-of-space-history/rocketeer-academy#:~:text=At%20the%20New%20Mexico%20Museum%20of%20Space%20History&text=New%20Mexico%20Rocketeer%20Academy%20has,museum%20or%20in%20your%20class.",
      "Program Contact": "Christopher Orwoll",
      Email: "(575) 437-2840"
    },
    {
      row_id: 91,
      "Program Name": "Science Girls Lab",
      Organization: "",
      "Program Support Mechanisms": "Train the Trainers, Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs, Teacher Training Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "Science",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Female",
      Overview: "\nProvide science activities, experiments, and experiences to teachers, students, and their families to inspire the next generation of scientists. Through various science experiences, boys and girls alike can see that science is more than words out of a textbook.   ",
      Partners: "",
      Website: "https://www.sciencegirlslab.com/",
      "Program Contact": "Melissa Alderete - Owner"
    },
    {
      row_id: 92,
      "Program Name": "SJC Kids Kollege at San Juan College",
      Organization: "San Juan College",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Farmington",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Rural",
      Overview: "This summer enrichment program provides a wide range of classes covering subjects such as science, technology, engineering, arts, mathematics, sports, and cooking. Through hands-on learning and interactive projects, students can deepen their knowledge and foster curiosity."
    },
    {
      row_id: 93,
      "Program Name": "Smart and Microgrid Training Center",
      Organization: "Santa Fe Community College",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "STEM Curriculums",
      Age: "College",
      "Curriculum Focus Area ": "Engineering, Technology",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "SMTC is a comprehensive center for training the next generation of smart- and micro-grid professionals. SMTC activities include the development of curriculum and courses, the launch of new degree and certificate programs, and dissemination of best practices to other two- and four-year academic institutions in New Mexico and beyond.",
      Partners: "",
      Website: "https://www.sfcc.edu/programs/facility-technologies/"
    },
    {
      row_id: 94,
      "Program Name": "Society for Women Engineers - Central New Mexico",
      Organization: "Society for Women Engineers",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary, Middle, HS, College",
      "Curriculum Focus Area ": "Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Female",
      Overview: "Advocacy group for increseasing access for women in engineering fields"
    },
    {
      row_id: 95,
      "Program Name": "SomosSTEM Summer Bridge Science Challenge Academy",
      Organization: "New Mexico Highlands University",
      "Program Support Mechanisms": "Higher Ed , Internships/WBL",
      "Type of Curriculum": "Work-based Learning opportunities, College-led STEM Outreach, Industry-Sponsored Programs/Internships",
      Age: "College",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "New Mexico Highlands University\u2019s (NMHU) SomosSTEM (\u201CWe are STEM\u201D) is an NSF (National Science Foundation) funded program. SomosSTEM engages students in more culturally informed, place and community-based undergraduate participation in STEM. The program involves students in life science community research pathways through the critical transition from lower to upper division coursework. Activities and experiences are used to support the development of a life science community that engages students, faculty, and community STEM partners. Grant activities include Course-based Undergraduate Research Experiences (CUREs); the SomosSTEM Summer Bridge Science Challenge Academy for college freshmen; a full summer internship program; and the Community Voices lecture series."
    },
    {
      row_id: 97,
      "Program Name": "Space Student Delegate  ",
      Organization: "SCOPE-NM ",
      "Program Support Mechanisms": "Industry Partnerships",
      "Type of Curriculum": "College-led STEM Outreach",
      Age: "College",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Student leader cohort that helps connect workforce with available opportunities. Resource-based ",
      Partners: "SCOPE-NM",
      Website: "https://library.scope-nm.org/join-us/students",
      "Program Contact": "Raven Delfino Otero",
      Email: "ravenotero@unmalumni.com"
    },
    {
      row_id: 98,
      "Program Name": "Space Teams Lab",
      Organization: "STEM Outreach Center/New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps, After-School STEM Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Space",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "week-long immersive space exploration experience for middle school students. Campers will explore virtual reality demos, build their own spacecraft, conduct a human space exploration mission, travel across the vast expanses of space, and explore a new planet while they collaborate, communicate, problem-solve and work as a team.",
      Partners: "New Mexico State University (NMSU)",
      Website: "https://stemcenter.nmsu.edu/camps/index.html#camp_options"
    },
    {
      row_id: 99,
      "Program Name": "Spaceport America Cup",
      Organization: "Experimental Sounding Rocket Association",
      "Program Support Mechanisms": "Industry Partnerships, Out of School Time (OST) Programs",
      "Type of Curriculum": "Competitions and Challenges, Science Fairs/Tech showcases",
      Age: "College",
      "Curriculum Focus Area ": "Space",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Over 1,700 students and faculty will gather in Southern New Mexico for the annual Spaceport America Cup. Drawn by the opportunity to collaborate and compete at a world-class spaceport facility, they represent the best and brightest from more than 150 institutions located all across the world.",
      Partners: "ESRA (Experimental Sounding Rocket Association)",
      Website: "https://spaceportamericacup.com/"
    },
    {
      row_id: 100,
      "Program Name": "Sparks After School Clubs",
      Organization: "Farmington Community Education",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary",
      "Curriculum Focus Area ": "STEM",
      Location: "Farmington",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Designed for youth in grades K-5, these clubs offer options in art, movement, drama, science, and technology, providing enriching experiences beyond the regular school day.",
      Partners: "",
      Website: "https://farmington.ce.eleyo.com/courses/category/163/youth-enrichment-and-sports/2-sparks-gr-k-5-camps-and-clubs/sparks-after-school-clubs?utm_source=chatgpt.com"
    },
    {
      row_id: 101,
      "Program Name": "STARBASE NM Advanced ",
      Organization: "Air Force Research Lab (AFRL)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Students work in teams with guidance from mentors who are STEM professionals. The teams design, build, and launch a rocket that will meet contect requirements for the national American Rocketry Challenge (ARC).\n\n6th \u2013 12th grade\n40 contact hours \nSchool-based mentorship program offered during elective of afterschool time \nA Teacher Sponsor must be available at the school",
      Partners: "",
      Website: "https://afrlnm.com/stem/missions/starbase-nm-advanced/",
      "Program Contact": "",
      Email: "stem@afrlnewmexico.com"
    },
    {
      row_id: 102,
      "Program Name": "STEAM Training and Mentorship ",
      Organization: "University of New Mexico (UNM) Health Sciences Center",
      "Program Support Mechanisms": "Higher Ed, Industry Partnerships, Internships/WBL",
      "Type of Curriculum": "College-led STEM Outreach, Career Exploration Platforms, Professional Dev/Coaching, Career Exploration virtual content",
      Age: "College",
      "Curriculum Focus Area ": "Biomedical/ Laboratory Research",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "This new NIH-funded program focuses on providing professional career development, mentoring, and networking opportunities for researchers at no cost. STEAM is open to US citizens participating in any cancer-related research at the graduate, post-doc, or junior faculty level from The University of New Mexico (UNM), New Mexico State University (NMSU), Burrell College of Osteopathic Medicine, or Northern Arizona University. ",
      Partners: "NIH",
      Website: "https://unmhealth.org/cancer/career/training-education/steam/"
    },
    {
      row_id: 103,
      "Program Name": "STEAMING Ahead for Success",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships, K- 12 Public education (In school time)",
      "Type of Curriculum": "STEM Curriculums, Industry Visits and Tours",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Silver City",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Rural",
      Overview: 'STEAMing Ahead for Success is collaborating with employers, educators and community members to ensure all students benefit from engaging, real world, high-quality STEAM programs. Through our collaborative effort, students in New Mexico will also have the opportunity to create valuable relationships through STEAM Mentoring Experiences. The "STEAMing Ahead for Success" program in New Mexico is designed for students in grades 6 through 8 and their families. It offers a multi-generational conservation initiative aimed at improving stewardship of natural resources. Participants engage in hands-on environmental conservation activities, fostering community responsibility and benefiting both individuals and the local ecosystem.',
      Partners: "",
      Website: "",
      "Program Contact": "",
      Email: "Maria Elena Garcia- Chief Executive Officer"
    },
    {
      row_id: 104,
      "Program Name": "STEM @ Home from NASA",
      Organization: "New Mexico Natural History Museum, NASA",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary, Middle",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Digital content for at home science and STEM learning",
      Partners: "",
      Website: "https://nmnaturalhistory.org/education/science-home"
    },
    {
      row_id: 105,
      "Program Name": "STEM Advancement Program",
      Organization: "NMEepscor",
      "Program Support Mechanisms": "Higher Ed, Internships/WBL",
      "Type of Curriculum": "Dual Credit/CTE (STEM), College-led STEM Outreach, Work-based Learning opportunities",
      Age: "College",
      "Curriculum Focus Area ": "Engineering, Space",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged, Rural, Tribal",
      Overview: "The STEM Advancement Program (STEMAP) engages students from New Mexico\u2019s regional universities, community colleges, and tribal colleges in the research funded by the New Mexico SMART Grid Center at UNM, New Mexico State University (NMSU), and NMT. Up to 12 students are selected to participate each summer; benefits include a $4,000 stipend, housing, and meal allowance. Academic year opportunities include support to present at state, regional, and national conferences, a webinar series, and continued research activities back at your home campus with a faculty mentor.",
      Partners: "",
      Website: "https://www.nmepscor.org/what-we-do/programs/stemap",
      "Program Contact": "Selena Connealy",
      Email: "connealy@epscor.unm.edu",
      Phone: "",
      "Link to Apply": "Not active as 2023"
    },
    {
      row_id: 106,
      "Program Name": "STEM at Spaceport America",
      Organization: "Spaceport America",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "Industry Visits and Tours",
      Age: "Elementary, Middle, HS, College",
      "Curriculum Focus Area ": "Space",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Site visits to Spaceport America give students from around the state of New Mexico the opportunity to learn more about the world's first purpose-built commercial spaceport, its tenants, and more. ",
      Partners: "",
      Website: "www.SpaceportAmerica.com",
      "Program Contact": "Charlie Hurley",
      Email: "Contact information for Spaceport America's STEM visit coordinators. Charlie Hurley | charles.hurley@spaceportamerica.com | 575.305.5257",
      Phone: "charles.hurley@spaceportamerica.com"
    },
    {
      row_id: 107,
      "Program Name": "STEM Challenge - NM STEM Academy",
      Organization: "Air Force Research Lab (AFRL)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "Competitions and Challenges",
      Age: "HS",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Students work in teams to design, build, and test both launching and payload protection devices that will send an egg payload through a hula hoop towards a target a specified distance away. Teams complete challenges that they submit online to earn points. The top 30 teams, based on points earned, qualify to participate in the annual STEM Challenge Symposium.\n\n9th \u2013 12th  grade\n15+ hours of curriculum \n4+ contact hours \nMission is school based\nTeacher training, materials, and online curriculum provided\nCulminating event in April for qualifying teams",
      Partners: "",
      Website: "https://afrlnm.com/stem/missions/stem-challenge/",
      "Program Contact": "",
      Email: "stem@afrlnewmexico.com"
    },
    {
      row_id: 108,
      "Program Name": "STEM Competitions - NM Technology Student Association",
      Organization: "New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "Competitions and Challenges",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "TSA competitions provide an opportunity for students to take learning beyond the classroom and explore topics of career interest. TSA provides rules and guidelines, that can be integrated into your STEM curriculum, for more than 75 middle school and high school competitions.",
      Partners: "",
      Website: "https://tsaweb.org/competitions"
    },
    {
      row_id: 109,
      "Program Name": "STEM Leadership Program and the STEAM Center of Excellence",
      Organization: "R4 Creating",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Train the Trainers",
      "Type of Curriculum": "After-School STEM Programs, Teacher Training Programs",
      Age: "Middle",
      "Curriculum Focus Area ": "STEM",
      Location: "Rio Rancho",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "We support individual student learning and STEM competitions statewide in robotics, drones, 3d printing, VR, STEM entrepreneurship, stop motion animation and more while also providing training and support for educators in addition to our 3d printing lending and support program. We are widely known for our championship robotics program, Girls Into Tech initiative, extensive outreach program, Fieldtrips and STEM learner to leader programs. We are most proud of the partnerships that we have developed in order to serve the entire state and build equity and access for students while also building the fudture workforce and pathways to success!",
      Partners: "",
      Website: "Www.R4Creating.org",
      "Program Contact": "Dr Shelly Gruenig",
      Email: "sagruenig@gmail.com"
    },
    {
      row_id: 110,
      "Program Name": "STEM Mavericks",
      Organization: "STEM Outreach Center/New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "HS",
      "Curriculum Focus Area ": "Engineering, Coding/CS",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "STEM Mavericks helps high school students begin their journey on the path to an exciting STEM career.\nThis two-week camp provides STEM Kits and Challenges to student participants that include all the hardware, software, and expert instruction they need to grow their STEM skill sets by solving real world challenges related to public safety and disaster relief.",
      Partners: "New Mexico State University (NMSU)",
      Website: "https://stemcenter.nmsu.edu/",
      "Program Contact": "",
      Email: "",
      Phone: "",
      "Link to Apply": "https://stemcenter.nmsu.edu/camps/index.html#camp_options"
    },
    {
      row_id: 111,
      "Program Name": "STEM Outreach",
      Organization: "Eastern New Mexico University (ENMU)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Train the Trainers, Industry Partnerships",
      "Type of Curriculum": "STEM Curriculums, After-School STEM Programs, Teacher Training Programs, Industry Visits and Tours",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Clovis",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Rural, Diversity",
      Overview: "The ENMU Hispanic Serving Institutions STEM program supports local schools with guest speakers, teacher curriculum assistance, and field trips to science labs. This initiative aims to introduce students to a variety of STEM careers and engage them in real-world science and research project"
    },
    {
      row_id: 112,
      "Program Name": "STEM Outreach",
      Organization: "Rural Education Advancement Program",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Out of School Time (OST) Programs, Train the Trainers, Higher Ed",
      "Type of Curriculum": "STEM Curriculums, Career Pathways Programs/WBL, After-School STEM Programs, Summer Camps and Bootcamps, Competitions and Challenges, Teacher Training Programs, Science Fairs/Tech showcases, Career Fairs, Professional Dev/Coaching, Mentorship Programs for Educators, Industry-Sponsored Programs/Internships, Work-based Learning opportunities, Industry Visits and Tours, Internship/Apprenticeship",
      Age: "Elementary, Middle, HS, Educator",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged, Diversity",
      Overview: "Rural Education Advancement Program (REAP)  is a non-profit 501(c)3. REAP was established to bring STEM programs to K-12 students in rural locations who may not otherwise have access to STEM education. Further, REAP seeks to increase the number of under represented populations in STEM related college fields and, in turn, in STEM related careers. Finally, building leadership is an integral piece of student success in STEM. With this in mind,  REAP's instructors are students, or former students,  who have gained STEM knowledge and skills while in the program.",
      Partners: "",
      Website: "reapnm.org",
      "Program Contact": "Creighton Edington",
      Email: "edington.creighton@gmail.com"
    },
    {
      row_id: 113,
      "Program Name": "STEM Outreach Center/ STEM Outreach Academy",
      Organization: "STEM Outreach Center/New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps, After-School STEM Programs",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "We provide high-quality, innovative Out-of-School-Time programs to K-12 students and educators. We design academic and enrichment curricula that nurtures 21st Century skills in science, technology, engineering, math, literature, and creative arts.",
      Partners: "New Mexico State University (NMSU)",
      Website: "https://stemcenter.nmsu.edu/",
      "Program Contact": "Sara Morales, Associate Director\n\n",
      Email: "smorales@nmsu.edu",
      Phone: "(575) 646-7649"
    },
    {
      row_id: 114,
      "Program Name": "STEM Pathways for Girls - STEM SF",
      Organization: "STEM SF",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Diversity, Female, Tribal",
      Overview: "STEM Santa Fe advocates for, develops and provides STEM programming, mentoring and resources for all youth, especially underrepresented groups in STEM, to realize their potential and expand their opportunities in a dynamic world.\nSTEM Santa Fe envisions a world filled with analytical citizens exploring complex issues for the betterment of society. An inspiring monthly program dedicated for girls and nonbinary students in 5th-8th grade. The program includes an inspiring one-day conference for 100-150 girls usually on a Saturday, augmented by monthly in-depth workshops and camps led by professional women in STEM. The girls experience new STEM hands-on activities in small groups and engage in a friendly, safe environment to make long-lasting friendships.\n\npriority is given to students in Northern New Mexico in the following counties",
      Partners: "",
      Website: "https://www.stemsantafe.org/"
    },
    {
      row_id: 115,
      "Program Name": "STEM Prep",
      Organization: "NM Alliance for Minority Participation/New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Higher Ed, Internships/WBL",
      "Type of Curriculum": "Dual Credit/CTE, College-led STEM Outreach, Work-based Learning opportunities",
      Age: "College",
      "Curriculum Focus Area ": "Biomedical/ Laboratory Research",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The STEM PREP program allows participants undergrads to participate in research activities that prepare them to enter the Undergraduate Research Scholars (URS) program, which they can apply for the next semester. STEM PREP allows the student to 1) explore research opportunities and identify a research mentor and project for the URS program for the next semester and 2) receive training in areas, such as lab safety, effective record keeping, and basic research techniques and methods to be used in the URS program. The STEM PREP stipend is $500 per student.",
      Partners: "New Mexico State University (NMSU)",
      Website: "https://nmamp.nmsu.edu/spde/stem_prep_program.html",
      "Program Contact": "",
      Email: "Phone: (575) 646-1847\nFax: (575) 646-2960\nEmail: nmamp@nmsu.edu"
    },
    {
      row_id: 116,
      "Program Name": "STEM Scaffold Santa Fe @ Middle and High Schools",
      Organization: "STEM SF",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Our middle & high school programs supplement students\u2019 STEM education with in-school, hands-on STEM & STEAM projects designed to engage & teach 21st century skills in small group settings with trained college students & STEM professional mentors. Our main goals are to increase students\u2019 interest & curiosity in STEM courses or careers, build communication, teamwork, & problem solving skills, and for our high school students, increase enrollment in STEM college courses while in high school and/or beyond.",
      Partners: "",
      Website: "https://www.stemsantafe.org/programs/stem-scaffold"
    },
    {
      row_id: 117,
      "Program Name": "STEM with Spaceport America",
      Organization: "New Mexico Spaceport Authority, New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "Career Exploration virtual content, Industry Visits and Tours, Professional Dev/Coaching",
      Age: "Elementary, Middle",
      "Curriculum Focus Area ": "Space",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Field trips, guest speakers, and hands-on space science programs aimed at getting students excited about space careers. Promoting educational involvement in spaceport activities, and education and training of the workforce to develop the skills needed for spaceport operations, is part of the mission of the New Mexico Spaceport Authority. We want people of all ages to get excited about space, and to pursue future careers in Science, Technology, Engineering and Mathematics (STEM). STEM with Spaceport America is an initiative started by the New Mexico Spaceport Authority team to engage students in science, technology, engineering and mathematics working in remote learning environments. These bite-sized videos are designed with at-home activities in mind. Use them as stand alone brain breaks, add to them with lesson plans or request a Spaceport America speaker to join your virtual classroom",
      Partners: "",
      Website: "https://www.spaceportamerica.com/education/"
    },
    {
      row_id: 118,
      "Program Name": "STEMarts ",
      Organization: "STEMarts ",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "HS",
      "Curriculum Focus Area ": "Space, Art",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Rural",
      Overview: "The STEMarts Youth in Space program is a Taos-based initiative designed to educate and foster a passion for space exploration and space policy through art, science and technology. Open to students from Taos County.",
      Partners: "STEMarts ",
      Website: "https://www.stemarts.com/"
    },
    {
      row_id: 119,
      "Program Name": "STEMarts Ambassador program",
      Organization: "STEMarts Lab",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Out of School Time (OST) Programs, Internships/WBL",
      "Type of Curriculum": "Special STEM Schools or Magnet Programs, Dual Credit/CTE (STEM), Summer Camps and Bootcamps, Competitions and Challenges, After-School STEM Programs, Work-based Learning opportunities, Career Exploration virtual content, Science Fairs/Tech showcases, Makerspace, Career Fairs, Professional Dev/Coaching, Internship/Apprenticeship",
      Age: "HS, College",
      "Curriculum Focus Area ": "STEM, Art",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Located in Northern New Mexico (Taos), the STEMarts Ambassador program provides training and professional mentorship for youth aged 14-25. Ambassadors receive a stipend while developing science and space literacy and gaining experience in event production, international collaboration, sci-art communication, Extended Reality (XR), and digital media art creation.",
      Partners: "",
      Website: "https://www.stemarts.com/",
      "Program Contact": "Agnes Chavez",
      Email: "stemartslab@gmail.com"
    },
    {
      row_id: 120,
      "Program Name": "STEMulus Center",
      Organization: "Central New Mexico Community College (CNM)",
      "Program Support Mechanisms": "Higher Ed , Industry Partnerships",
      "Type of Curriculum": "Makerspace, Science Fairs/Tech showcases, Summer Camps and Bootcamps",
      Age: "College",
      "Curriculum Focus Area ": "Robotics, Engineering, Coding/CS, Technology, Computer Science",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "\nThe CNM STEMulus Center, powered by CNM Ingenuity, is a hub for innovation and technology in downtown Albuquerque. It is the home of the Deep Dive Bootcamps, ActivateNM, and Hyperspace Challenge, and serves as a place to connect entrepreneurs and tech lovers.",
      Partners: "CNM Ingenuity",
      Website: "https://www.cnm.edu/locations/stemulus-center"
    },
    {
      row_id: 121,
      "Program Name": "Student Success Agency",
      Organization: "GEAR UP / New Mexico Higher Education Department",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Out of School Time (OST) Programs",
      "Type of Curriculum": "Professional Dev/Coaching, Career Exploration virtual content",
      Age: "HS, College",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Student-Centered Virtual Mentorship: Through GEAR UP New Mexico\u2019s partnership with Student Success Agency, students can receive monthly messaging about academic college, career, and life success through their freshman year of college. In addition to mentorship, student can also receive unlimited tutoring from SSA specialists and resources about FAFSA completion and scholarships."
    },
    {
      row_id: 122,
      "Program Name": "Summer College Internship",
      Organization: "Sandia National Labs",
      "Program Support Mechanisms": "Internships/WBL, Industry Partnerships",
      "Type of Curriculum": "Industry-Sponsored Programs/Internships",
      Age: "College",
      "Curriculum Focus Area ": "Biomedical/ Laboratory Research",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Our internships provide students Opportunities to work on challenging projects at competitive pay\nAcademic credits for some co-op and other internships\nResearch mentoring from top scientists and engineers\nTraining and practical work experience using state-of-the-art equipment and instruments\nIn some cases, internships can also lead to an offer of full-time employment",
      Partners: "Sandia National Labs",
      Website: "https://www.sandia.gov/careers/career-possibilities/students-and-postdocs/internships-co-ops/"
    },
    {
      row_id: 123,
      "Program Name": "Summer Community College Opportunity for Research Experience (SCCORE)",
      Organization: "NM Alliance for Minority Participation/New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Internships/WBL, Higher Ed",
      "Type of Curriculum": "Dual Credit/CTE, College-led STEM Outreach, Work-based Learning opportunities",
      Age: "College",
      "Curriculum Focus Area ": "Biomedical/ Laboratory Research",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged, Diversity",
      Overview: "Targeted to community college students in all STEM fields, the annual Summer Community College Opportunity for Research Experience (SCCORE) program supports pre-transfer community college students to serve as research assistants to university faculty mentors in their related fields. The program provides an excellent overview of the host university, including an orientation to campus resources and university life. Participating students live on campus, attend a credit-bearing class, and receive professional development training. All students present their research at a culminating SCCORE Poster Symposium and at the NM AMP Student Research Conference at New Mexico State University the subsequent fall semester.",
      Partners: "New Mexico State University (NMSU)",
      Website: "https://nmamp.nmsu.edu/programs/sccore.html",
      "Program Contact": "",
      Email: "Phone: (575) 646-1847\nFax: (575) 646-2960\nEmail: nmamp@nmsu.edu"
    },
    {
      row_id: 124,
      "Program Name": "Summer Internship Program W/ Inbre",
      Organization: "New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Higher Ed, Internships/WBL, Industry Partnerships",
      "Type of Curriculum": "Work-based Learning opportunities, College-led STEM Outreach",
      Age: "College",
      "Curriculum Focus Area ": "Biomedical/ Laboratory Research",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "This 8-week, full-time summer research program focused on lab-oriented Bioinformatics internships at New Mexico or RAIN institutions: ENMU, NMHU, NMTech, NNCC, SJC",
      Partners: "New Mexico Idea Networks for Biomedical Research Excellence (NM INBRE) through New Mexico State University (NMSU)",
      Website: "https://nminbre.org/nise-overview/summer-programs/",
      "Program Contact": "",
      Email: "nminbre@nmsu.edu",
      Phone: "575-646-2783"
    },
    {
      row_id: 125,
      "Program Name": "Summer Physics Camp for Young Women (2025)",
      Organization: "Los Alamos National Labs",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Internships/WBL, Industry Partnerships",
      "Type of Curriculum": "Summer Camps and Bootcamps, Industry-Sponsored Programs/Internships, Work-based Learning opportunities",
      Age: "HS",
      "Curriculum Focus Area ": "Physics, Engineering, Coding/CS",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Female",
      Overview: "2024 Summer Physics Camp for Young Women\nA two-week free camp for students that focuses on STEM and Energy Security.",
      Partners: "",
      Website: "https://www.lanl.gov/careers/career-options/student-internships/high-school/womens-summer-physics-camp.php"
    },
    {
      row_id: 126,
      "Program Name": "Summer STEM Circles",
      Organization: "STEM SF",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Rural, Tribal",
      Overview: "STEM Circles Circles offer a variety of topics for rising middle and high school students. These are designed to be one-week long with each STEM Circle focused on a single theme related to STEM and STEAM topics.",
      Partners: "",
      Website: "https://www.stemsantafe.org/programs/stem-circles"
    },
    {
      row_id: 127,
      "Program Name": "Summer STEM Experience 2025",
      Organization: "New Mexico Institute of Mining and Technology (NMIMT)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "Summer Camps and Bootcamps, Work-based Learning opportunities, Internship/Apprenticeship",
      Age: "HS",
      "Curriculum Focus Area ": "Technology, Engineering, Physics",
      Location: "Socorro",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: " The Summer STEM Experience provides a week long overnight camp for high school students to learn about life as a college student and gain experience in an array of STEM fields: Tech, engineering, physics",
      Partners: "",
      Website: "https://apply.nmt.edu/portal/summer_stem",
      "Program Contact": "",
      Email: "https://www.nmt.edu/contact.php"
    },
    {
      row_id: 128,
      "Program Name": "Supercomputing Challenge",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Competitions and Challenges",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Technology, Math",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "\nThe Supercomputing Challenge is an exciting academic year-long marathon competition open to middle and high school students to solve real-world problems using computational science techniques.",
      Partners: "",
      Website: "https://supercomputingchallenge.org/",
      "Program Contact": "David Kratzer",
      Email: "consult@supercomputingchallenge.org"
    },
    {
      row_id: 130,
      "Program Name": "Teacher Professional Development Workshop",
      Organization: "Space Foundation",
      "Program Support Mechanisms": "Train the Trainers",
      "Type of Curriculum": "Teacher Training Programs",
      Age: "Educator",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "\u201CWe're excited to provide Albuquerque educators with the opportunity to explore the wonders of the cosmos, deepen their understanding of astronomy, and gain the tools and knowledge to engage and inspire their students to pursue a STEM career,\u201D ",
      Partners: "",
      Website: "https://www.spacefoundation.org/2024/06/26/space-foundation-partners-with-new-mexico-space-grant-consortium-to-host-teacher-professional-development-workshop/",
      "Program Contact": "Rich Cooper- Vice President, Strategic Communications & Outreach\n",
      Email: "(202) 596-0714\nrcooper@spacefoundation.org"
    },
    {
      row_id: 131,
      "Program Name": "Tech Girls at X Studio",
      Organization: "Explora",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle, Elementary",
      "Curriculum Focus Area ": "Coding/CS, Robotics",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Female",
      Overview: "Be inspired and empowered! Become a creator during this special coding program. Learn to code, program robots, use Micro:bits, create wearable technology, and design your own project to address real-world problems (no programming experience required)."
    },
    {
      row_id: 132,
      "Program Name": "TECH Mission",
      Organization: "Air Force Research Lab (AFRL)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle",
      "Curriculum Focus Area ": "Space, Technology",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Students explore applications of basic STEM concepts and the engineering design process. Fall semester focuses on model rocketry content and spring semester focuses on satellites.\n\n6th \u2013 8th grade\n15 contact hours \nMission is conducted at the AFRL NM STEM Academy\nTeacher orientation provided\n3 non-consecutive 5-hour classes at Kirtland AFB",
      Partners: "",
      Website: "https://afrlnm.com/stem/missions/tech-mission/",
      "Program Contact": "",
      Email: "stem@afrlnewmexico.com"
    },
    {
      row_id: 133,
      "Program Name": "Tech Trek  AAUW",
      Organization: "AAUW of New Mexico, New Mexico Institute of Mining and Technology (NMIMT)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Middle",
      "Curriculum Focus Area ": "STEM",
      Location: "Socorro",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Through hands-on problem solving and encounters with women role models in science, technology, engineering, and math (STEM), AAUW Tech Trek helps girls see their futures while having nonstop fun. This one-week summer camp is backed by AAUW\u2019s research and designed to make STEM fields exciting and accessible to girls in middle school \u2014 the age when girls\u2019 participation in these fields statistically drops. For many girls, the week long camp sparks their curiosity and places them on a path toward success.",
      Partners: "",
      Website: "https://aauw-nm.aauw.net/",
      "Program Contact": "Meredith Machen",
      Email: "Meredith.Machen@gmail.com"
    },
    {
      row_id: 134,
      "Program Name": "Technology Leadership High School",
      Organization: "PED - Magnet/Charter Schools",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Internships/WBL",
      "Type of Curriculum": "STEM Curriculums, Special STEM Schools or Magnet Programs, Work-based Learning opportunities",
      Age: "HS",
      "Curriculum Focus Area ": "Technology, Math, Engineering, Science",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged",
      Overview: "This high school focuses on STEM, especially technology-related career pathways, such as IT, coding, and digital design.",
      Partners: "",
      Website: "https://www.techabq.org/"
    },
    {
      row_id: 136,
      "Program Name": "The Aerospace Adventures Program",
      Organization: "New Mexico 4-H",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Space",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "A part of the 4-H youth development programs in New Mexico, it provides students with aerospace education and hands-on learning experiences. 4-H provides youth with opportunities to learn skills, gain knowledge, have fun, and make contributions in such areas as environmental education, community service, and current youth issues",
      Partners: "NMSU",
      Website: "https://nm4h.nmsu.edu/"
    },
    {
      row_id: 137,
      "Program Name": "The Intelligent Energetic Systems Engineering (INTENSE) REU",
      Organization: "New Mexico Institute for Mining and Technology (NMTech)",
      "Program Support Mechanisms": "Higher Ed , Internships/WBL",
      "Type of Curriculum": "Work-based Learning opportunities, College-led STEM Outreach, Industry-focused curriculum/training, Dual Credit/CTE",
      Age: "College",
      "Curriculum Focus Area ": "Robotics, Physics",
      Location: "Socorro",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The Intelligent Energetic Systems Engineering (INTENSE) REU at New Mexico Tech will engage undergraduate students in unique research related to robotics, smart materials, explosives, high-speed fluid dynamics, and shock physics. Students involved in this REU will complete individual research and design projects directly related to federally-funded research being performed at NMT; building skills, knowledge, and exposure to science, technology, engineering, and mathematics (STEM) disciplines relevant to these national hiring needs.",
      Partners: "New Mexico Institute for Mining and Technology (NMTech)",
      Website: "https://www.nmt.edu/academics/mecheng/intense/index.php",
      "Program Contact": "\nThe PIs Dr. Michael Hargather and Dr. Mostafa Hassanalian of the Mechanical Engineering Department both receive emails from this email address and will respond as soon as possible. ",
      Email: " For general inquiries, please email: intense.reu@nmt.edu\n"
    },
    {
      row_id: 138,
      "Program Name": "The Minority Educational Institution Student Partnership Program",
      Organization: "US Dept of Energy (DOE)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "College",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged, Diversity",
      Overview: "Do you want to expand your professional skills, energy literacy, and leadership capabilities while networking with top professionals in the Department of Energy? The Minority Educational Institution Student Partnership Program (MEISPP) provides 12-week summer internship opportunities to highly qualified undergraduate and graduate students and recent graduates from eligible Minority Serving Institutions. Some opportunities may be extended into the academic year.",
      Partners: "",
      Website: "https://www.zintellect.com/Opportunity/Details/DOE-MEISPP-2024?utm_source=opportunity_digest&utm_medium=email&utm_campaign=dpp_orau_msi"
    },
    {
      row_id: 139,
      "Program Name": "The NASA Science, Engineering, Mathematics and Aerospace Academy (SEMAA)",
      Organization: "NASA",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Elementary",
      "Curriculum Focus Area ": "Space, Technology",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The SEMAA program focuses on teaching students science, engineering, mathematics and aeronautics in a setting where students can make connections to real-world application and improving their environments. Students participate in hands-on STEM-based activities that encourage them to find an interest in science and mathematics while learning about the world they live in. Key topics include gardening, recycling, wind power, and the water cycle.",
      Partners: "New Mexico State University (NMSU)"
    },
    {
      row_id: 140,
      "Program Name": "The New Mexico Out-of-School Time Network (NMOST)",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Career Pathways Programs/WBL",
      Age: "HS, Middle, Elementary",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The New Mexico Out-of-School Time Network (NMOST) is a non-profit collaboration of public and private organizations and community members seeking to improve access to and quality of out-of-school extended learning programs \u2013 before and after school, summer learning, and youth development.",
      Partners: "",
      Website: "https://nmost.org/",
      "Program Contact": "May Sagbakken",
      Email: "https://nmost.org/contact/ nmostnetwork@gmail.com"
    },
    {
      row_id: 141,
      "Program Name": "The Quantum REACH (QU_REACH) Internship program",
      Organization: "University of New Mexico (UNM)",
      "Program Support Mechanisms": "Higher Ed, Internships/WBL",
      "Type of Curriculum": "Industry-focused curriculum/training, Work-based Learning opportunities",
      Age: "College",
      "Curriculum Focus Area ": "Technology, Coding/CS",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The QU-REACH Program at the University of New Mexico (UNM) is a ten-week summer undergraduate research program run by the Center for High Technology Materials (CHTM) and academic departments on UNM\u2019s Main Albuquerque campus. Projects are available in a broad range of disciplines (Physics, Chemistry, Engineering, etc.) related to the three cornerstones of Quantum Technology: Quantum Sensing, Quantum Communications, and Quantum Computing\n",
      Partners: "The University of New Mexico (UNM)",
      Website: "https://qureach.unm.edu/",
      "Program Contact": "",
      Email: "",
      Phone: "",
      "Link to Apply": "",
      "# of Students Served": "53"
    },
    {
      row_id: 142,
      "Program Name": "The Summer Science Program",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Internships/WBL, Industry Partnerships",
      "Type of Curriculum": "After-School STEM Programs, College-led STEM Outreach, Career Pathways Programs/WBL",
      Age: "HS",
      "Curriculum Focus Area ": "Biomedical/ Laboratory Research",
      Location: "Socorro",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "a residential enrichment program designed to challenge and inspire talented and motivated high school students (rising seniors) from around the world\none of the longest-running (since 1959) pre-college programs\nan immersion into hands-on research. Each team completes a real research project, taking and analyzing original data. Afterward, they join a worldwide network of 2,500+ alumni of all ages. In 2024 we will operate 12 programs: five in Astrophysics: research in near-earth asteroid orbit determination at New Mexico State Univ.",
      Partners: "",
      Website: "https://summerscience.org/",
      "Program Contact": "   "
    },
    {
      row_id: 143,
      "Program Name": "The Undergraduate Student Internship Program",
      Organization: "Los Alamos National Labs (LANL)",
      "Program Support Mechanisms": "Internships/WBL, Industry Partnerships",
      "Type of Curriculum": "Industry-Sponsored Programs/Internships, Work-based Learning opportunities",
      Age: "College",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The Undergraduate Student Internship Program is a year-round internship program that provides domestic and international students with relevant research experience while they are pursuing an undergraduate degree. It is designed to complement your education with work experience related to your chosen field of study and offers opportunities in both technical and professional fields. This applies to entering first year undergrads, current undergraduate students and post-bachelor\u2019s interns.",
      Partners: "",
      Website: "https://collaboration.lanl.gov/student-programs/undergrad/"
    },
    {
      row_id: 144,
      "Program Name": "theCoderSchool Farmington",
      Organization: "THE CODER SCHOOL",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Elementary",
      "Curriculum Focus Area ": "Coding/CS",
      Location: "Farmington",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Offering coding camps designed to help kids understand STEM topics through interactive, hands-on experiences, theCoderSchool makes complex concepts accessible and engaging for younger students."
    },
    {
      row_id: 145,
      "Program Name": "TRIO Talent Search Summer Science STEM Camp",
      Organization: "Eastern New Mexico University (ENMU)",
      "Program Support Mechanisms": "Higher Ed , Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Middle",
      "Curriculum Focus Area ": "STEM",
      Location: "Clovis",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Hosted at ENMU in Portales, this camp provides 8th-grade students with hands-on STEM activities from June 3-6, 2024. The program is free and includes all necessary materials"
    },
    {
      row_id: 146,
      "Program Name": "Undergraduate Research Scholars (URS)",
      Organization: "NM Alliance for Minority Participation, New Mexico State University (NMSU)",
      "Program Support Mechanisms": "Higher Ed, Internships/WBL",
      "Type of Curriculum": "Dual Credit/CTE, College-led STEM Outreach, Work-based Learning opportunities",
      Age: "College",
      "Curriculum Focus Area ": "Biomedical/ Laboratory Research",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged",
      Overview: "The Undergraduate Research Scholars (URS) program, available on several campuses statewide, supports students in faculty-mentored research projects and provides professional development and preparation for internships, graduate school, and/or the workforce. Participating students receive training in presentation development and encouragement to present research at national conferences, including the NM AMP Student Research Conference. The URS program also prepares students to consider opportunities to pursue a graduate degree.",
      Partners: "New Mexico State University (NMSU)",
      Website: "https://nmamp.nmsu.edu/programs/urs.html",
      "Program Contact": "",
      Email: "\nnmamp@nmsu.edu",
      Phone: "Phone: (575) 646-1847"
    },
    {
      row_id: 147,
      "Program Name": "University NanoSatellite Program",
      Organization: "Air Force Research Labs (AFRL)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Internships/WBL, Industry Partnerships",
      "Type of Curriculum": "Work-based Learning opportunities, Industry-Sponsored Programs/Internships, Industry Visits and Tours",
      Age: "College",
      "Curriculum Focus Area ": "Space",
      Location: "Kirtland Air Force Base",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The University Nanosatellite Program (UNP) funds U.S. university students and programs to design, build, launch, and operate small satellites. UNP is funded by the Air Force Office of Scientific Research (AFOSR) and managed from the Air Force Research Laboratory\u2019s (AFRL) Space Vehicles Directorate (RV) located on Kirtland Air Force Base, NM. UNP is a nationally recognized Science, Technology, Engineering, and Math workforce training program. UNP\u2019s objective is to train the next generation of space professionals by providing a rigorous concept-to-flight-ready spacecraft development process centered on systems engineering principles and practices. UNP provides AFRL and DoD parties the option to leverage technologies and platforms in research areas of interest to AFRL. Finally, UNP provides AFRL and industry a work force pipeline made up of students who have been trained in small satellite development. In 1999, UNP was synonymous with the Nanosatellite (NS) cycle of small satellite development from universities, with professional mentoring led by AFRL. NS is a four phased cycle where multiple university teams are funded to develop their systems with the goal of achieving a flight ready system.",
      Partners: "",
      Website: "https://universitynanosat.org/",
      "Program Contact": "Lee Jasper",
      Email: "Lee.Jasper@sdl.usu.edu"
    },
    {
      row_id: 148,
      "Program Name": "UNM Space Day 2024",
      Organization: "University of New Mexico (UNM)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed , Industry Partnerships",
      "Type of Curriculum": "College-led STEM Outreach, Science Fairs/Tech showcases",
      Age: "College",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "A day of activities focused on science, exploration, technology, and opportunities will take place November 13, 2024 in UNM Student Union Building Ballroom C."
    },
    {
      row_id: 149,
      "Program Name": "UNM Sustainable Space Research Grand Challenge",
      Organization: "University of New Mexico (UNM)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed , Industry Partnerships",
      "Type of Curriculum": "Competitions and Challenges, College-led STEM Outreach, Industry-focused curriculum/training",
      Age: "College",
      "Curriculum Focus Area ": "Space",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Our mission is to expand New Mexico's scientific, creative, and economic horizons beyond Earth through university, commercial, and national lab collaboration.Develop a center of space science-exploration excellence on the UNM campuses by identifying and uniting relevant and diverse space expertise and maturing an appropriate research-technology infrastructure.\nUse this multidisciplinary team to competitively seek space research and exploration funding.\nPartner with the national laboratories and private companies to build a New Mexico Space Economy.\nEngage students from a variety of disciplines to develop a future work force and an entrepreneurial foundation for growing a Space Economy.\nEngage the citizens of New Mexico in educational outreach;  communicate and coordinate space related activities with the State legislature and governor\u2019s office.\nBy fulfilling goals 1-5, develop a New Mexico space economy that will benefit the citizens of New Mexico. \n",
      Partners: "",
      Website: "https://grandchallenges.unm.edu/space.html"
    },
    {
      row_id: 150,
      "Program Name": "UNM-Taos PreK-12 Program",
      Organization: "University of New Mexico (UNM)",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Pre-K, HS, Middle, Elementary",
      "Curriculum Focus Area ": "STEM",
      Location: "Northern New Mexico",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The PreK-12 program is focused on preparing area students for college & career readiness, which included STEM educational experiences and opportunities.",
      Partners: "UNM-Taos "
    },
    {
      row_id: 151,
      "Program Name": "Upward Bound",
      Organization: "Clovis Community College",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Professional Dev/Coaching, After-School STEM Programs",
      Age: "HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Clovis",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "This college prep program includes elements of STEM education for high school students who meet income or first-generation college student criteria. Our federally-funded TRIO program provides high school students with educational opportunities designed to prepare them for higher education and beyond."
    },
    {
      row_id: 152,
      "Program Name": "Vamos Ninos ",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Pre-K",
      "Curriculum Focus Area ": "STEM",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged",
      Overview: "Early childhood education enrichment in STEAM - The mobile museum brings a caravan of health, wellness, and educational resources and \u200Bservices to rural and underserved children and families, fostering equitable educational \u200Bopportunities across Do\xF1a Ana County.",
      Partners: "Vamos Ninos ",
      Website: "https://vamosninos.my.canva.site/vamos-ni-os-play-to-learn-eng"
    },
    {
      row_id: 153,
      "Program Name": "Verizon Innovative Learning STEM Achievers ",
      Organization: "National Association for Community College Entrepreneurship (NACCE)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Middle",
      "Curriculum Focus Area ": "Technology, STEM",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged",
      Overview: "The Verizon Innovative Learning STEM Achievers program empowers middle school students from under-resourced schools to build STEM and entrepreneurship skills through hands-on instruction using next-gen technology.",
      Partners: "New Mexico State University (NMSU) - Dept. of Computer Science",
      Website: "https://vil.nmsu.edu/",
      "Program Contact": "",
      Email: "nmsu_vil@nmsu.edu",
      Phone: "",
      "Link to Apply": "https://nacce.formstack.com/forms/2022_2023_vilsap_registration_form_copy_copy_24"
    },
    {
      row_id: 155,
      "Program Name": "WildWorks",
      Organization: "Silver City Public Library",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs",
      Age: "Middle",
      "Curriculum Focus Area ": "Robotics, Technology",
      Location: "Silver City",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "WildWorks: Thursdays at 4:00pm. Experiment and create with robots, electronics, games, crafting, 3D drawing, photo editing and more! Ages 10+, free, open to the public, no registration necessary. Contact the Silver City Public Library at 575-538-3672 or programs@silvercitymail.com for more information.",
      Partners: "",
      Website: "",
      "Program Contact": "Lillian Galloway",
      Email: "",
      Phone: "575-538-3672 or ref@silvercitymail.com."
    },
    {
      row_id: 157,
      "Program Name": "Workforce Development Bus Tours",
      Organization: "GEAR UP / New Mexico Higher Education Department",
      "Program Support Mechanisms": "K- 12 Public education (In school time)",
      "Type of Curriculum": "Industry Visits and Tours, Career Exploration virtual content, Science Fairs/Tech showcases",
      Age: "HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "In partnership with FOCUS Training, high school students explore career pathways by visiting diverse workplaces locally and across New Mexico. Students connect with experienced professionals and educators to learn about occupations, jobs, shadowing, internships, and apprenticeships available to them. Students will also learn about the steps to finding a job with little or no work experience and receive resources for finding jobs, developing resumes, writing cover letters, and preparing for interviews.",
      Partners: "",
      Website: "https://studentsuccess.co/"
    },
    {
      row_id: 158,
      "Program Name": "X3 Internships - Future Focus Education ",
      Organization: "Future Focus Education",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Out of School Time (OST) Programs, Internships/WBL, Industry Partnerships",
      "Type of Curriculum": "Work-based Learning opportunities, Dual Credit/CTE, Internship/Apprenticeship",
      Age: "HS, College",
      "Curriculum Focus Area ": "Technology",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Future Focused Education is a New Mexico-based initiative that aims to prepare young people for successful futures through experiential learning and work-based education. Their flagship program, X3 Internships, is designed for high school students, ages 14-24, to engage in paid internships that earn them school credit while developing professional skills. The X3 program connects students with local employers in fields like healthcare, construction, technology, and design, offering real-world job experience while supporting their educational journey.",
      Partners: "LANL Foundation, NM PED",
      Website: "https://futurefocusededucation.org/initiatives/#x3-internships"
    },
    {
      row_id: 160,
      "Program Name": "Young Women in Computing Camp (YWiC)",
      Organization: "New Mexico State University (NMSU) - Dept. of Computer Science",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "College-led STEM Outreach, Summer Camps and Bootcamps",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Coding/CS",
      Location: "Las Cruces/Dona Ana County",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Female",
      Overview: "1) Build community among young women through computing;\n2) Increase young women\u2019s interest in computing;\n3) Gain knowledge and experience with programming languages; and\n4) Drastically increase young women\u2019s confidence in Computer Science.",
      Partners: "",
      Website: "https://ywic.nmsu.edu/programs/ywicsummercamps.html",
      "Program Contact": "Mari Langford",
      Email: "ywic@nmsu.edu\n(575) 646-1901"
    },
    {
      row_id: 162,
      "Program Name": "The Nonlinear Mechanics and Dynamics (NOMAD)",
      Organization: "The University of New Mexico (UNM)",
      "Program Support Mechanisms": "Internships/WBL, Higher Ed",
      "Type of Curriculum": "Industry-Sponsored Programs/Internships, Internship/Apprenticeship",
      Age: "College",
      "Curriculum Focus Area ": "Physics",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The Nonlinear Mechanics and Dynamics (NOMAD) Research Institute seeks to tackle research challenges in the field of nonlinear mechanics and dynamics by forming diverse teams of B.S., M.S., and Ph.D. students, as well as post-doctoral and earlycareer researchers. The program is sponsored by Sandia National Laboratories and the University of New Mexic",
      Partners: "Sandia National Labs"
    },
    {
      row_id: 164,
      "Program Name": "Native Americans in Science, Technology, Engineering and Mathematics (NASTEM)",
      Organization: "The University of New Mexico (UNM)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "College-led STEM Outreach",
      Age: "College",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Tribal",
      Overview: "This program at the University of New Mexico provides support services to Native American students majoring in STEM fields. They offer academic support, workshops, and scholarships. ",
      Partners: "",
      Website: "https://ess.unm.edu/assets/ess-programs/nastem/index.html#:~:text=The%20Native%20Americans%20in%20Science,American%20Program%2C%20School%20of%20Engineering%20%2D&text=NA%2DSTEM%20provides%20a%20supportive,offers%20academic%20scholarships%20to%20assist",
      "Program Contact": "Douglas Williams",
      Email: "dougwms@unm.edu"
    },
    {
      row_id: 165,
      "Program Name": "The American Indian Science and Engineering Society (AISES)",
      Organization: "The University of New Mexico (UNM)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "College-led STEM Outreach",
      Age: "College",
      "Curriculum Focus Area ": "Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Tribal",
      Overview: "The American Indian Science and Engineering Society (AISES) is a private, nonprofit organization, which nurtures building of community by bridging science and technology with traditional Native values. Through its education program, AISES provides opportunities for Native Americans and Alaskan Natives to pursue studies in Science, Engineering, Business, and other academic areas. The trained professionals then become technologically informed leaders within the Native American community. AISES' advancement of Native Americans as they seek to become self-reliant and self-determined members of society.",
      Partners: "",
      Website: "",
      "Program Contact": "",
      Email: "aisesunm@gmail.com"
    },
    {
      row_id: 166,
      "Program Name": "Society for the Advancement of Chicanos/Hispanics and Native American in Science Lobos (SACNAS Lobos)",
      Organization: "Society for the Advancement of Chicanos/Hispanics and Native American in Science (SACNAS)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "College-led STEM Outreach, Mentorship",
      Age: "College",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Tribal, Disadvantaged, Female",
      Overview: "The Lobos chapter of SACNAS strives to support students by providing academic and career mentorship and guidance. All students, regardless of major or career goals, are encouraged to engage withe the Lobos chapter to explore career opportunities and additional preparation throughout their tenure at UNM (and beyond!). We offer networking events, mentoring, research experience opportunities, graduate school preparation (including waivers!), and much more!",
      Partners: "The University of New Mexico (UNM)",
      Website: "",
      "Program Contact": "",
      Email: "sacnaslobos@unm.edu"
    },
    {
      row_id: 167,
      "Program Name": "Advancing Women in Science",
      Organization: "The University of New Mexico (UNM)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "Professional Dev/Coaching, College-led STEM Outreach",
      Age: "College",
      "Curriculum Focus Area ": "STEM",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Disadvantaged, Female",
      Overview: "UNM Club: Academic Support Student Support Professional Development",
      Partners: "",
      Website: "https://unm-community.symplicity.com/index.php?mode=form&id=151499eeb87045e3a2243ec65a79ad3c"
    },
    {
      row_id: 169,
      "Program Name": "National Society of Black Engineers (UNM Chapter)",
      Organization: "The University of New Mexico (UNM)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "Professional Dev/Coaching, College-led STEM Outreach",
      Age: "College",
      "Curriculum Focus Area ": "Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Diversity",
      Overview: `Mission: "To increase the number of culturally responsible black engineers who excel academically, succeed professionally and positively impact the community."Our emphasis is on community outreach, professional development, and academic advancement. A few the opportunities available to our members include attending the National and Regional Conventions, NSBE Kid's Day, socials, scholarships, and more!`,
      Partners: "",
      Website: "https://www.unm.edu/~sixhouse//#",
      "Program Contact": "",
      Email: "nsbe.unm@gmail.com"
    },
    {
      row_id: 171,
      "Program Name": "Indigitize",
      Organization: "",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Out of School Time (OST) Programs, Industry Partnerships",
      "Type of Curriculum": "STEM Curriculums",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "Coding/CS, Technology",
      Location: "Tribal",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "Tribal",
      Overview: "Our goal is to engage 10,000 Indigenous students in Indigenized computer science experiences by working directly with schools, districts, and teachers. There are not enough educational pathways for Native youth to meaningfully engage with technology and computer science.",
      Partners: "Navajo Technical University",
      Website: "https://www.indigitize.org/"
    },
    {
      row_id: 173,
      "Program Name": "MechE Mayhem Robotics Education Program (Formerly The Robot Outreach program)",
      Organization: "New Mexico Institute of Mining and Technology (NMIMT)",
      "Program Support Mechanisms": "Higher Ed , Out of School Time (OST) Programs",
      "Type of Curriculum": "Competitions and Challenges, STEM Curriculums, Teacher Training Programs",
      Age: "Elementary, Middle, HS, College, Educator",
      "Curriculum Focus Area ": "Engineering, Robotics",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The newly rebranded New Mexico Tech MechE Mayhem Robotics Education Program is an open-source comprehensive educational curriculum developed by engineering and science students at New Mexico Institute of Mining and Technology to assist in the education of future NM STEM student. Our program seeks to provide engaging hands-on, STEM projects and classroom curriculum support to k-12 schools across the state of New Mexico. In the 2023-24 academic year we supported programs and events at 47 schools and engaged with over 6,000 students and teachers. ",
      Partners: "",
      Website: "https://sites.google.com/student.nmt.edu/nmt-meche-mayhem/home"
    },
    {
      row_id: 174,
      "Program Name": "Army Educational Outreach Program (AEOP)",
      Organization: "White Sands Missle Range",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Internships/WBL",
      "Type of Curriculum": "Work-based Learning opportunities",
      Age: "HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Las Cruces/Dona Ana County, Alamogordo",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "What do cutting edge research, state-of-the-art laboratory facilities and unparalleled access to professional scientists and engineers have in common? The AEOP High School Internship. Spend your summer in a university research lab or in one of the U.S. Army Research Laboratories and Centers through this unique internship opportunity. You will experience firsthand the innovation and research that is driving the future of our country. Do something meaningful this summer to prepare you for competitive college admissions and the next step in your STEM journey. Submit your application today for a chance to participate in the AEOP Internship Program. The impacts of this transformative experience will last a lifetime.",
      Partners: "",
      Website: "https://www.usaeop.com/program/high-school-internships/"
    },
    {
      row_id: 175,
      "Program Name": "Engineering and Computing Summer Academy (STEM Summer Program For High School Students)",
      Organization: "University of New Mexico; School of Engineering",
      "Program Support Mechanisms": "Higher Ed , Internships/WBL",
      "Type of Curriculum": "Work-based Learning opportunities, College-led STEM Outreach, Internship/Apprenticeship",
      Age: "HS",
      "Curriculum Focus Area ": "Engineering, Coding/CS",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "This 4-week commuter program offers students STEM activities and learning experiences in engineering and computer science fields. There are themed weeks to learn from, including field trips and a variety of hands-on activities.",
      Partners: "",
      Website: "https://ess.unm.edu/programs/k-12-opportunities/ess-summer-programs/summeracademyflyer.pdf"
    },
    {
      row_id: 176,
      "Program Name": "Central NM STEM Research Challenge Regional Fair ",
      Organization: "University of New Mexico (UNM)",
      "Program Support Mechanisms": "Higher Ed , K- 12 Public education (In school time)",
      "Type of Curriculum": "Science Fairs/Tech showcases",
      Age: "Elementary, Middle, HS",
      "Curriculum Focus Area ": "Science, Engineering",
      Location: "Albuquerque Area",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Central NM STEM Research Challenge is a three division (elementary, middle and high school students), multiple category regional student competition of science and engineering projects.",
      Partners: "",
      Website: "https://hsc.unm.edu/stem-h/programs/challenge/"
    },
    {
      row_id: 177,
      "Program Name": "New Mexico Science and Engineering Fair (State Competition)",
      Organization: "New Mexico Institute of Mining and Technology (NMIMT)",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Higher Ed",
      "Type of Curriculum": "Science Fairs/Tech showcases",
      Age: "HS, Middle",
      "Curriculum Focus Area ": "Engineering, Science",
      Location: "Socorro",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The 70th Annual New Mexico Science and Engineering Fair will be held April 1-2, 2022 on the New Mexico Tech campus in Socorro.  Exhibitors at the State Science and Engineering Fair have qualified to attend through their Regional Science Fair competition."
    },
    {
      row_id: 178,
      "Program Name": "New Mexico Science Olympiad",
      Organization: "New Mexico Institute of Mining and Technology (NMIMT)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "Science Fairs/Tech showcases, Competitions and Challenges",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "STEM",
      Location: "Socorro",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Founded in 1984, Science Olympiad is the premier team STEM competition in the nation, providing standards-based challenges to 6,300 teams at 425 tournaments in all 50 states. 2025 Rules available 9/3/24, followed by fall workshops and national Workshop Wednesdays showcasing innovative content. Become a member through your State Chapter to play, study using 46 event pages for Div B and Div C, and check out prep materials from our SO Store plus official kits from Ward's Science. Check out the MYSO archive for Lesson Plans and STEM career videos on our SOTV YouTube page!",
      Partners: "",
      Website: "https://scioly24.my.canva.site/39th-annual-new-mexico-science-olympiad-state-championships"
    },
    {
      row_id: 179,
      "Program Name": "Team Drone New Mexico",
      Organization: "New Mexico Institute of Mining and Technology (NMIMT); SystemsGo New Mexico",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "After-School STEM Programs, Summer Camps and Bootcamps, Teacher Training Programs, Competitions and Challenges",
      Age: "HS, Educator",
      "Curriculum Focus Area ": "STEM, Engineering, Technology",
      Location: "Socorro",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "We seek to promote New Mexico's mission in increasing enrollment in STEM fields and outreach activities through starting a state and eventually nationwide \u201CK-12 Drone-program at NMT\u201D. New Mexico Tech in partnership with SystemGo New Mexico wants to improve education in America by inspiring students, teachers, and administrators within the present educational system. New Mexico Tech drone program would motivate and equip high school students to develop 21st-century skills and pursue careers in STEM disciplines. New Mexico Tech drone program (Team Drone New Mexico) will be a high-level STEM Engineering curriculum in which high school students in their junior and senior years will design and build different types of fixed-wing or multirotors Micro Air Vehicles (MAVs) for well-defined missions.",
      Partners: "",
      Website: "https://sites.google.com/nmt.edu/nmtdrone/home"
    },
    {
      row_id: 180,
      "Program Name": "SystemsGo New Mexico",
      Organization: "SystemsGo",
      "Program Support Mechanisms": "K- 12 Public education (In school time), Out of School Time (OST) Programs",
      "Type of Curriculum": "STEM Curriculums, After-School STEM Programs",
      Age: "HS",
      "Curriculum Focus Area ": "STEM, Space, Engineering",
      Location: "Artesia, Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "SystemsGo New Mexico is proud to be a part of improving education in America by inspiring students, teachers, and administrators within the present educational system. SystemsGo New Mexico motivates and equips high school students to develop 21st century skills and pursue careers in science, technology, engineering, and mathematics.",
      Partners: "",
      Website: "https://www.systemsgonm.com/"
    },
    {
      row_id: 181,
      "Program Name": "First Tech Challenge New Mexico",
      Organization: "",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "After-School STEM Programs, Summer Camps and Bootcamps",
      Age: "Middle, HS",
      "Curriculum Focus Area ": "Robotics, Engineering, Coding/CS",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Designed for students in grades 7-12 to compete head to head, using a sports model and to transition students from FIRST\xAE Lego League to the next level of robotics. Teams are responsible for designing, building, and programming their robots to compete in an alliance format against other teams. Teams, including coaches, mentors and volunteers, are required to develop strategy and build robots based on sound engineering principles. Awards are given for the competition as well as for community outreach, design, and other real-world accomplishments. Students learn to cooperate with those you are in competition with, as well as gracious professionalism. FIRST\xAE Tech Challenge student out perform their peers in life due to the enriching experiences they have participating in FIRST\xAE Tech Challenge",
      Partners: "",
      Website: "https://nmftc.org/"
    },
    {
      row_id: 182,
      "Program Name": "Middle School Expo at NM Tech",
      Organization: "New Mexico Institute of Mining and Technology (NMIMT)",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Higher Ed",
      "Type of Curriculum": "Summer Camps and Bootcamps",
      Age: "Middle",
      "Curriculum Focus Area ": "STEM",
      Location: "Socorro",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "The Middle School Expo is a program for 120 middle school students to come and experience a day at NM Tech!"
    },
    {
      row_id: 183,
      "Program Name": "Skills USA New Mexico",
      Organization: "Skills USA",
      "Program Support Mechanisms": "Out of School Time (OST) Programs, Industry Partnerships, Internships/WBL, Train the Trainers",
      "Type of Curriculum": "",
      Age: "HS, College, Adult",
      "Curriculum Focus Area ": "",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "SkillsUSA is a partnership of students, teachers, and industry working together to ensure America has a skilled workforce. With the help of dedicated teachers, SkillsUSA New Mexico reaches thousands of middle, high school, and college / postsecondary students. Each element of SkillsUSA programming is based upon a framework that illustrates the importance of personal, workplace, and technical skills grounded in academics.",
      Partners: "",
      Website: "https://skillsusanm.org/about/"
    },
    {
      row_id: 184,
      "Program Name": "CAREER TECHNICAL LEADERSHIP PROJECT",
      Organization: "New Mexico CTLP",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "",
      Age: "",
      "Curriculum Focus Area ": "",
      Location: "",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Working to ensure that every student in New Mexico has the opportunity to be an active member of a Career Technical Student Organization developing personal, leadership, academic, and technical skills that business and industry recognize as a value to society.",
      Partners: "",
      Website: "https://nmctso.com/"
    },
    {
      row_id: 185,
      "Program Name": "New Mexico Business Professionals of America",
      Organization: "Business Professionals of America",
      "Program Support Mechanisms": "Out of School Time (OST) Programs",
      "Type of Curriculum": "",
      Age: "College",
      "Curriculum Focus Area ": "Technology",
      Location: "Statewide",
      "Inclusivity: Urban, Rural, Tribal, disadvantaged, female": "",
      Overview: "Business Professionals of America is the nation\u2019s leading CTSO (Career and Technical Student Organization) for students pursuing careers in business management, information technology, finance, accounting, office administration, and other business-related career fields. New Mexico BPA has been a chartered association since 1967. This is over 55 years of leadership history!  BPA supports business and information technology educators by offering intra-curricular exercises that are aligned with nationally recognized industry standards. The Workplace Skills Assessment Program (WSAP) is an integral part of Business Professionals of America. The goal of the program is to provide all business students with the opportunity to demonstrate workplace skills learned through business education curricula. Students prepare for and compete in contests in over 90 categories, under five assessment areas including:\n\nFinance\nBusiness Administration\nManagement Information Systems\nDigital Communication & Design\nManagement, Marketing, & Communication\nHealth Administration",
      Partners: "Eastern New Mexico University",
      Website: "https://nmctso.com/bpa/",
      "Program Contact": "Christine Phipps",
      Email: "Christine.phipps@enmu.edu",
      Phone: "(575) 562-4729"
    }
  ]
};

// disciplines.json
var disciplines_default = {
  stem: {
    slug: "stem",
    label: "STEM",
    icon: "omega",
    description: "Programs in STEM",
    display: true
  },
  space: {
    slug: "space",
    label: "Space",
    icon: "rocket",
    description: "Programs in Space",
    display: true
  },
  engineering: {
    slug: "engineering",
    label: "Engineering",
    icon: "wrench",
    description: "Programs in Engineering",
    display: true
  },
  technology: {
    slug: "technology",
    label: "Technology",
    icon: "cpu",
    description: "Programs in Technology",
    display: true
  },
  codingcs: {
    slug: "codingcs",
    label: "Coding/CS",
    icon: "file-code",
    description: "Programs in Coding/CS",
    display: true
  },
  math: {
    slug: "math",
    label: "Math",
    icon: "calculator",
    description: "Programs in Math",
    display: true
  },
  robotics: {
    slug: "robotics",
    label: "Robotics",
    icon: "bot",
    description: "Programs in Robotics",
    display: true
  },
  "biomedical-laboratory-research": {
    slug: "biomedical-laboratory-research",
    label: "Biomedical/ Laboratory Research",
    icon: "scan-heart",
    description: "Programs in Biomedical/ Laboratory Research",
    display: true
  },
  science: {
    slug: "science",
    label: "Science",
    icon: "microscope",
    description: "Programs in Science",
    display: true
  },
  physics: {
    slug: "physics",
    label: "Physics",
    icon: "orbit",
    description: "Programs in Physics",
    display: true
  },
  healthcare: {
    slug: "healthcare",
    label: "Healthcare",
    icon: "heart-pulse",
    description: "Programs in Healthcare",
    display: true
  },
  art: {
    slug: "art",
    label: "Art",
    icon: "brush",
    description: "Programs in Art"
  },
  conservation: {
    slug: "conservation",
    label: "Conservation",
    icon: "leaf",
    description: "Programs in Conservation"
  },
  ai: {
    slug: "ai",
    label: "AI",
    icon: "brain-circuit",
    description: "Programs in AI",
    display: true
  },
  "nuclear-science": {
    slug: "nuclear-science",
    label: "Nuclear Science",
    icon: "radiation",
    description: ""
  },
  "computer-science": {
    slug: "computer-science",
    label: "Computer Science",
    icon: "laptop",
    description: "Programs in Computer Science",
    display: true
  }
};

// src/lib/utils/parse-url.ts
var parseUrl = (website) => {
  if (website) {
    const uri = website.startsWith("http") ? website : `https://${website}`;
    const url = new URL(uri);
    return {
      display: url.hostname,
      uri
    };
  }
};

// src/lib/utils/slugify.ts
var slugify2 = (str) => str.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");

// src/lib/data/index.ts
var getPrograms = (data) => {
  return new DataParser({
    data,
    columns: {
      name: {
        trim: true,
        accessorFn(row) {
          return row["Program Name"].trim();
        }
      },
      location: {
        accessorFn(row) {
          return row.Location;
        }
      },
      programSupportMechanisms: {
        accessorFn(row) {
          return splitter(row["Program Support Mechanisms"]);
        }
      },
      ages: {
        filterEmpty: true,
        accessorFn(row) {
          const rawAges = splitter(row.Age);
          return rawAges.map((a) => {
            if (a === "HS") {
              return "High School";
            }
            return a;
          });
        }
      },
      by: {
        accessorFn(row) {
          return row.Organization;
        }
      },
      website: {
        accessorFn(row) {
          const website = row.Website;
          return parseUrl(website);
        },
        getUniqueValues(row) {
          const website = row.Website;
          if (website) {
            const uri = website.startsWith("http") ? website : `https://${website}`;
            return [uri];
          }
          return [];
        }
      },
      curriculumFocusAreas: {
        filterEmpty: true,
        accessorFn(row) {
          return row["Curriculum Focus Area "].split(", ");
        },
        getLabelValue(val) {
          const slug = slugify2(val);
          if (slug in disciplines_default) {
            return disciplines_default[slug];
          }
          return {
            label: val,
            slug
          };
        }
      },
      curriculumTypes: {
        filterEmpty: true,
        accessorFn(row) {
          return row["Type of Curriculum"].split(", ");
        }
      },
      // locationSlug: {
      //   accessorFn(row) {
      //     return slugify(row.Location);
      //   },
      // },
      overview: {
        accessorFn(row) {
          return row.Overview;
        }
      },
      slug: {
        accessorFn(row) {
          const slugData = [row["Program Name"]];
          if (row.Organization) {
            slugData.push(row.Organization);
          }
          return slugify2(slugData.join(" "));
        }
      }
    }
  });
};
var Programs = class _Programs {
  constructor(data, title) {
    this.parser = getPrograms(data);
    this.title = title;
  }
  get programs() {
    return this.parser.getData();
  }
  static get instance() {
    return new _Programs(data_default.data);
  }
  get websites() {
    const websites = this.parser.getColumn("website").getUniqueValues().map((w) => w.label);
    return websites;
  }
  get locations() {
    const locs = this.parser.getColumn("location").getUniqueValues().map((l) => __spreadProps(__spreadValues({}, l), {
      name: l.label
    }));
    return locs;
  }
  getCurriculumFocusAreaDisplay(_filter = true) {
    const curriculums = this.parser.getColumn("curriculumFocusAreas").getUniqueValues();
    return curriculums.map((cur) => {
      return __spreadValues({
        icon: "calculator"
      }, cur);
    }).sort((a, b) => {
      return b.count - a.count;
    });
  }
  getCurriculumDisplay(filter = true) {
    const curriculums = this.parser.getColumn("curriculumTypes").getUniqueValues();
    return curriculums.map((cur) => {
      const cType = getCurriculumType(cur.label);
      return __spreadValues(__spreadProps(__spreadValues({}, cur), {
        display: false,
        icon: Calculator,
        description: ""
      }), cType);
    }).filter((c) => {
      if (filter) {
        return c.display;
      }
      return true;
    });
  }
  getAgeDisplay() {
    const ages = this.parser.getColumn("ages").getUniqueValues();
    const ageSort = (a) => {
      const ages2 = [
        "Pre-K",
        "Elementary",
        "Middle",
        "High School",
        "College",
        "Educator",
        "Adult"
      ];
      return ages2.indexOf(a);
    };
    return ages.map((age) => {
      return __spreadProps(__spreadValues({}, age), {
        sortKey: ageSort(age.label),
        display: true
      });
    }).sort((a, b) => a.sortKey - b.sortKey);
  }
  getOrganizationDisplay() {
    const organizations = this.parser.getColumn("by").getUniqueValues();
    return organizations.map((org) => {
      return __spreadProps(__spreadValues({}, org), {
        display: true
      });
    });
  }
  filterByOrganization(organizationSlug) {
    const organization = this.getOrganizationDisplay().find(
      (o) => o.slug === organizationSlug
    );
    if (!organization) {
      return new _Programs([]);
    }
    return {
      programs: this.parser.filterColumnBySlug("by", organizationSlug),
      title: organization.label
    };
  }
  filterByCurriculumFocusArea(curriculumFocusAreaSlug) {
    const curriculumFocusArea = this.getCurriculumFocusAreaDisplay(false).find(
      (c) => c.slug === curriculumFocusAreaSlug
    );
    if (!curriculumFocusArea) {
      return new _Programs([]);
    }
    return {
      programs: this.parser.filterColumnBySlug(
        "curriculumFocusAreas",
        curriculumFocusAreaSlug
      ),
      title: curriculumFocusArea.label
    };
  }
  filterByAge(ageSlug) {
    const age = this.getAgeDisplay().find((a) => a.slug === ageSlug);
    if (!age) {
      return new _Programs([]);
    }
    return {
      programs: this.parser.filterColumnBySlug("ages", ageSlug),
      title: age.label
    };
  }
  filterByService(serviceSlug) {
    const services = this.getCurriculumDisplay(false);
    const service = services.find((s) => s.slug === serviceSlug);
    if (!service) {
      return new _Programs([]);
    }
    return {
      programs: this.parser.filterColumnBySlug("curriculumTypes", serviceSlug),
      title: service.label
    };
  }
  filterByLocation(locationSlug) {
    const programs = this.parser.filterColumnBySlug("location", locationSlug);
    const title = this.locations.find((l) => {
      return l.slug === locationSlug;
    });
    return {
      programs,
      title: title == null ? void 0 : title.name
    };
  }
  getProgram(slug) {
    return this.parser.findRowBySlug("slug", slug);
  }
};

// src/index.ts
function programData() {
  return "program data";
}
export {
  CurriculumTypes,
  Programs,
  programData as default,
  getCurriculumType,
  getPrograms,
  slugify
};
/*! Bundled license information:

lucide-react/dist/esm/shared/src/utils.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/defaultAttributes.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/Icon.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/createLucideIcon.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/book-open-check.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/briefcase-business.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/calculator.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/flame-kindling.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/icons/trophy.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

lucide-react/dist/esm/lucide-react.js:
  (**
   * @license lucide-react v0.487.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)
*/
